import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { computeFinalResult } from "../../Utils/computeFinalResult";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import {
  calculateEffortRate,
  getCustomIncomeDetails,
  haveValue,
  shouldDeductNextView,
  isDefaulter,
  toast,
  amlKycChecks,
  getFieldForPolicies,
  calculateFinalScore,
  getRentPercentage,
  calculateOverlayScore,
  getCustomIncome,
  getUserDisplayName,
  getIdentityDetails,
  haveMissingDniOrNieFromVerifiedSource,
  formatPropertyAddress,
  toTitleCase,
  resolveIncomeSelection,
} from "../../helper/common";
import AuthContext from "../../context/auth/AuthContext";
import AwardPropertyPopup from "./AwardPropertyPopup";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import LandLordContext from "../../context/landlord/LandLordContext";
import Cancelimg from "../../assets/img/cancel-01.svg";
import CloseIcon from "../../assets/img/closeIcon.svg";
import SkorDefaultLoader from "../../assets/img/skorDefaultLoader.gif";
import UserIcon from "../../assets/img/user-icon.svg";
import Loader from "../Loader";
import LoadingSpinner from "../LoadingSpinner";
import SuccessAwardedPropModal from "./SuccessAwardedPropModal";
import ServingPromptModal from "../../pages/landlord/profile-request/ServingPromptModal";
import PurchaseInsurancePopup from "./PurchaseInsurance";
import AwardInsuranceConfirmPopup from "./AwardInsuranceConfirmPopup";
import moment from "moment";
import { IoStopwatchOutline } from "react-icons/io5";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import ButtonActionTooltip from "../ErrorModal/ButtonActionTooltip";
import {
  CheckIcon,
  DocIcon,
  DownloadIcon,
  OutlineShieldIcon,
  PencilEditIcon,
  ShieldIcon,
} from "../../helper/svgHelper";
import RiskAssessmentReport from "./RiskAssessmentReport";
import InsuranceReviewModal from "./InsuranceReviewModal";
import InsuranceSimulationErrorsModal from "./InsuranceSimulationErrorsModal";
import "./LinkedPropertiesPopup.css";

const checkIsProfilePending = (tenant, profileId) => {
  return tenant?.tenant_extra_field_id?.landlord_ids_for_forensic_notification?.some(
    (i) => i?.profile_id === profileId
  );
};

const LinkedPropertiesPopup = ({
  detailsShow,
  setDetailsShow,
  setPropData,
  property,
  tanentData,
  handleSaveChanges,
  saveTanentLoading,
  setSelectedTanents,
  selectedTanents,
  searchText,
  setSearchText,
  onPropertyAward,
  setPreselectedTanents,
  setsaveTanentLoading,
  loadData,
  currentLang,
  onEditProperty,
}) => {
  const LINKED_REPORT_CACHE_PREFIX = "linked-report-cache-";
  const LINKED_REPORT_CACHE_TTL_MS = 10 * 60 * 1000;
  const { _t } = useTranslator();
  const location = useLocation();
  const STATUS_STYLES = {
    yellow: {
      backgroundColor: "#FFFBEC",
      color: "#E1BB20",
      textColor: "#61380A",
      border: ".1389vw solid #F2E09B",
      text: _t("manualReview"),
      img: "/images/warning.svg",
      fw: "600",
      deaIndividualText: _t("reviewDea"),
    },
    grey: {
      backgroundColor: "#F7F7F7",
      color: "#253837",
      border: ".1389vw solid #E6E6E6",
      text: _t("selectTenantsToCheckApproval"),
      fw: "500",
      deaIndividualText: _t("notFoundDea"),
    },
    green: {
      backgroundColor: "#F2FBE9",
      color: "#82CF3F",
      textColor: "#0C4B25",
      border: ".1389vw solid #DAECC8",
      text: _t("approved"),
      img: "/images/tick-new.svg",
      fw: "600",
      deaIndividualText: _t("eligibleDea"),
    },
    red: {
      backgroundColor: "#FFE2E2",
      color: "#FF3C3C",
      border: ".1389vw solid #EB9B9C",
      text: _t("notApproved"),
      img: "/images/notApproved.svg",
      fw: "600",
      deaIndividualText: _t("hardFailDea"),
    },
  };
  const isPropertyAwarded = property?.is_awarded;
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const authContext = useContext(AuthContext);
  const landLordContext = useContext(LandLordContext);
  const queryParameters = new URLSearchParams(window.location.search);
  const getInitialSharedProfileIds = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlIds = urlParams.getAll("sharedprofileid");
    if (urlIds.length > 0) {
      sessionStorage.setItem("awardSelectedTenants", JSON.stringify(urlIds));
      return urlIds;
    }
    const storedIds = sessionStorage.getItem("awardSelectedTenants");
    if (storedIds) {
      const parsedIds = JSON.parse(storedIds);
      sessionStorage.removeItem("awardSelectedTenants");
      return parsedIds;
    }
    return [];
  };
  const initialSharedProfileIdsRef = useRef(getInitialSharedProfileIds());
  const recommendationRunIdRef = useRef(0);
  const { user, setLoading } = authContext;
  const {
    multiPropAward,
    awardApplicationToProperty,
    sendInvitationToTenant,
    multiPropUnAward,
    getShareProfilesForProperty,
    updatePropertyDetails,
    customPolicyDetails,
    deaWorkspace,
    checkInsuranceDocumentStatus,
    runInsuranceSimulation,
    checkMutuaConsents,
    unlinkApplicationFromProperty,
    editSharedProfile,
  } = landLordContext;
  const runIdRef = useRef(0);

  const [awardPopupModal, setAwardPopupModal] = useState(false);
  const [insuracePopupModal, setInsuracePopupModal] = useState(false);
  const [showAwardInsurancePopup, setShowAwardInsurancePopup] = useState(false);
  const [isInsuranceSimulationSuccess, setIsInsuranceSimulationSuccess] =
    useState(false);
  const [simulatedInsuranceCost, setSimulatedInsuranceCost] = useState(null);
  const [preFilledInsuranceDocument, setPreFilledInsuranceDocument] =
    useState(null);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [totalCombinedIncome, setToalCombinedIncome] = useState(0);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [sharerEmail, setSharerEmail] = useState(null);
  const [sharerName, setSharerName] = useState(null);
  const [sendInvitationLoading, setSendInvitationLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showUnAwardSuccessPopup, setShowUnAwardSuccessPopup] = useState(false);
  const [successTenant, setSuccessTenant] = useState([]);
  const [propertyAwardedSelectedTenant, setPropertyAwardedSelectedTenant] =
    useState([]);
  const [propertyShareProfiles, setPropertyShareProfiles] = useState([]);
  const [linkingTenantIds, setLinkingTenantIds] = useState([]);
  const [unlinkingTenantIds, setUnlinkingTenantIds] = useState([]);
  const [servingPromptModal, setServingPromptModal] = useState(false);
  const [servingPromptModalURL, setServingPromptModalURL] = useState("");
  const [currentProfile, setCurrentProfile] = useState(null);
  const [rent, setRent] = useState(property?.report_rent ?? 0);
  const [propertyRentError, setPropertyRentError] = useState(false);
  const [tenantResults, setTenantResults] = useState({});
  const [guarantorResults, setGuarantorResults] = useState({});
  const [deaResult, setDeaResult] = useState([]);
  const [allDeaResult, setAllDeaResult] = useState({});
  const [statusStyle, setStatusStyle] = useState(STATUS_STYLES.grey);
  const [giveInsurance, setGiveInsurance] = useState(false);
  const [resultLoader, setResultLoader] = useState(false);
  const [finalRenderedResult, setFinalRenderedResult] = useState(null);
  const [finalScoreModel, setFinalScoreModel] = useState(false);
  const [finalScoreModelData, setFinalScoreModelData] = useState(null);
  const [finalEffortRate, setFinalEffortRate] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const [showRiskAssessmentReportModal, setShowRiskAssessmentReportModal] =
    useState(false);
  const [riskReportData, setRiskReportData] = useState();
  const [lastShowAddGuarantor, setLastShowAddGuarantor] = useState(false);
  const [lastVerdict, setLastVerdict] = useState(null);
  const [lastRecommendationFlags, setLastRecommendationFlags] = useState({});

  const handleCloseRiskAssessmentReportModal = () => {
    setShowRiskAssessmentReportModal(false);
    setRiskReportData(null);
  };
  const [checkStatusLoading, setCheckStatusLoading] = useState(false);
  const [simulationLoading, setSimulationLoading] = useState(false);
  const simulationCacheRef = useRef({});
  const lastSimulationKeyRef = useRef(null);
  const [insuranceSimulationErrorModal, setInsuranceSimulationErrorModal] =
    useState(false);
  const [insuranceSimulationErrors, setInsuranceSimulationErrors] = useState(
    []
  );
  const [simulationDidNotRun, setSimulationDidNotRun] = useState(false);
  const [simulationPropertyErrors, setSimulationPropertyErrors] = useState([]);
  const [simulationConsentErrors, setSimulationConsentErrors] = useState([]);
  const [awardInsuranceSimulationLoading, setAwardInsuranceSimulationLoading] =
    useState(false);
  const isRecommendationRulesActivated =
    user?.current_workspace?.recommendation_rules_activated === true;
  const isDeaRulesActivated =
    user?.current_workspace?.dea_rules_activated === true && deaWorkspace;
  const [showInsuranceReviewModal, setShowInsuranceReviewModal] =
    useState(false);
  const [openApplicationIds, setOpenApplicationIds] = useState({});
  const [isDownloadDocList, setIsDownloadDocList] = useState(false);
  const [lastToastTime, setLastToastTime] = useState(null);
  const TOAST_BUFFER_MS = 2000;

  useEffect(() => {
    const sortedIds = selectedTenant
      .map((t) => t?.tenantid?._id)
      .filter(Boolean)
      .sort()
      .join(",");
    const currentKey = `${sortedIds}__${rent}`;
    const cached = simulationCacheRef.current[currentKey];
    if (cached && currentKey === lastSimulationKeyRef.current) {
      setIsInsuranceSimulationSuccess(cached.isInsurable);
      setSimulatedInsuranceCost(cached.insuranceCost ?? null);
      setPreFilledInsuranceDocument(cached.preFilledDocument ?? null);
      setSimulationDidNotRun(false);
      setSimulationPropertyErrors([]);
      setSimulationConsentErrors([]);
    } else {
      setIsInsuranceSimulationSuccess(false);
      setSimulatedInsuranceCost(null);
      setPreFilledInsuranceDocument(null);
      setSimulationDidNotRun(false);
      setSimulationPropertyErrors([]);
      setSimulationConsentErrors([]);
    }
  }, [rent, selectedTenant]);

  const isInsuranceEnabledWorkspace = true;
  // ["UY5I2V"].includes(
  //   user?.current_workspace?.uuid
  // );

  useEffect(() => {
    const initialIds = initialSharedProfileIdsRef.current;

    if (haveValue(initialIds) && haveValue(propertyShareProfiles)) {
      const idSet = new Set(initialIds);
      const filteredEntries = propertyShareProfiles.filter((item) =>
        idSet.has(item._id)
      );

      initialSharedProfileIdsRef.current = [];

      setSelectedTenant(filteredEntries);
    }
  }, [propertyShareProfiles]);

  useEffect(() => {
    if (!isRecommendationRulesActivated) {
      setFinalRenderedResult(null);
      return;
    }

    if (!selectedTenant || selectedTenant.length === 0) {
      setFinalRenderedResult(null);
      return;
    }

    if (resultLoader) return;
    if (!tenantResults || Object.keys(tenantResults).length === 0) return;

    recommendationRunIdRef.current += 1;
    const currentRunId = recommendationRunIdRef.current;

    const timer = setTimeout(() => {
      try {
        // ❗ Ignore stale runs
        if (recommendationRunIdRef.current !== currentRunId) return;

        const res = renderFinalResult();

        if (recommendationRunIdRef.current !== currentRunId) return;

        setFinalRenderedResult(res);
      } catch (e) {
        console.log(e);
      } finally {
        // ❗ Prevent stale loader reset
        if (recommendationRunIdRef.current === currentRunId) {
        }
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [
    tenantResults,
    guarantorResults,
    selectedTenant,
    giveInsurance,
    resultLoader,
    enabled,
    isRecommendationRulesActivated,
  ]);

  const fetchShareProfileData = async (showLoading = false, setList = true) => {
    try {
      if (showLoading) {
        setsaveTanentLoading(true);
      }

      const data = await getShareProfilesForProperty(property?._id);

      setPropertyShareProfiles(data?.sharedProfiles ?? []);
      if (data?.sharedProfiles) {
        const dataArray = Array.isArray(data.sharedProfiles)
          ? data.sharedProfiles
          : [];

        const updatedData = dataArray.flatMap((item) => {
          const application = item?.application_id;
          const tenant = item?.tenant_id || item?.tenantid;
          if (application?.participants?.length > 0) {
            return application.participants.map((participant) => {
              const tenantInfo = participant?.tenant_info;
              return {
                label: getUserDisplayName(tenantInfo),
                value: tenantInfo?._id,
              };
            });
          }
          return {
            label: tenant?.fname + " " + (tenant?.lname ?? ""),
            value: tenant?._id,
          };
        });

        setPreselectedTanents(updatedData);

        if (setList) {
          setSelectedTanents(updatedData.map((item) => item.value));
        }
      }
    } catch (error) {
      console.log("Failed to fetch data", error);
    } finally {
      if (showLoading) {
        setsaveTanentLoading(false);
      }
    }
  };

  useEffect(() => {
    setStatusStyle(STATUS_STYLES.grey);
    if (!isDeaRulesActivated && !isRecommendationRulesActivated) {
      setTenantResults({});
      setGuarantorResults({});
      setDeaResult([]);
      setFinalRenderedResult(null);
      getStatusStyle();
      return;
    }

    if (
      selectedTenant?.length > 0 &&
      haveValue(customPolicyDetails?.scoringConfig) &&
      haveValue(customPolicyDetails?.overlayConfig) &&
      haveValue(customPolicyDetails?.policyConfig)
    ) {
      console.log("GOING IN IF");
      runIdRef.current += 1;
      const currentRunId = runIdRef.current;

      // Optional: Clear previous results

      //Remove later

      if (isDeaRulesActivated) {
        setTenantResults({});
        setGuarantorResults({});

        setDeaResult([]);

        policyCalculate(currentRunId);
      } else {
        setTenantResults({});
        setGuarantorResults({});
        policyCalculate(currentRunId);
        // getStatusStyle();
      }
    }
  }, [
    selectedTenant,
    customPolicyDetails,
    rent,
    giveInsurance,
    user,
    isDeaRulesActivated,
    isRecommendationRulesActivated,
  ]);

  useEffect(() => {
    if (!haveValue(searchText)) {
      fetchShareProfileData(true, true);
    }
  }, []);

  useEffect(() => {
    setRent(property?.report_rent);
  }, [property]);

  useEffect(() => {
    if (!rent) {
      setPropertyRentError(true);
    } else {
      setPropertyRentError(false);
    }
  }, [rent]);

  useEffect(() => {
    if (!rent) {
      setPropertyRentError(true);
    } else {
      setPropertyRentError(false);
    }
  }, [rent]);

  useEffect(() => {
    if (!isDeaRulesActivated) {
      return;
    }

    if (deaResult?.length > 0) {
      setResultLoader(true);

      // ✅ Flatten dataset
      const allProfiles = deaResult.flatMap((tenant) => [
        tenant,
        ...(tenant?.guarantors || []),
      ]);

      const highPointProfile = allProfiles.reduce((max, current) => {
        if (!max) return current;

        return current?.DEA_SCORE?.finalScore > max?.DEA_SCORE?.finalScore
          ? current
          : max;
      }, null);

      const profilesHaveMissingDocs = allProfiles.some(
        (item) => item?.vals?.DOCUMENTATION > 0
      );

      const hasHardFailEntries = allProfiles.some(
        (item) => item?.errorEntries?.length > 0
      );

      const haveMissingDniOrNie =
        haveMissingDniOrNieFromVerifiedSource(allProfiles);

      // 🎯 SAME DECISION LOGIC
      if (hasHardFailEntries) {
        setStatusStyle(STATUS_STYLES.red);
      } else if (
        highPointProfile?.DEA_SCORE?.finalScore > 4 &&
        !profilesHaveMissingDocs &&
        !haveMissingDniOrNie
      ) {
        setStatusStyle(STATUS_STYLES.green);
      } else {
        setStatusStyle(STATUS_STYLES.yellow);
      }

      setResultLoader(false);
    }
  }, [deaResult, isDeaRulesActivated]);

  async function policyCalculate(currentRunId) {
    setResultLoader(true);
    try {
      let tenantIncomeSum = 0;
      let guarantorIncomeSum = 0;
      const tempGuarantorResults = {};

      //   #NOTE: if the (selectedTenant) which is a sharedProfile is an application tyep
      // then we check if it is an application then we use each participant from the application

      const selectedSharedProfiles = selectedTenant
        .flatMap((s) => {
          const application = s?.application_id;
          if (application?.participants?.length > 0) {
            return application?.participants.map((participant) => {
              return {
                ...s,
                tenantid: participant?.tenant_info,
              };
            });
          } else {
            return s;
          }
        })
        .filter((sp) => sp.tenantid);

      // ---- SAME INCOME LOGIC ----
      for (let entry of selectedSharedProfiles) {
        const incomeSelection = resolveIncomeSelection(
          entry?.income_selection,
          entry?.tenantid?._id
        );
        const tenantInfo = entry?.tenantid;

        const tenantIncome = getCustomIncomeDetails(
          tenantInfo,
          user,
          _t,
          incomeSelection?.tenant_source,
          undefined,
          undefined,
          deaWorkspace,
          entry?.custom_income_sources
        );

        const tenantIncomeAmount = tenantIncome?.amount ?? 0;
        tenantInfo._localIncome = tenantIncomeAmount;
        tenantIncomeSum += tenantIncomeAmount;

        const guarantors = tenantInfo?.gurantor_id || [];

        const guarantorResults = await Promise.all(
          guarantors.map(async (g) => {
            const guarantorIncomeObj = getCustomIncomeDetails(
              g,
              user,
              _t,
              incomeSelection?.guarantor_sources?.[g?._id],
              undefined,
              undefined,
              deaWorkspace,
              entry?.custom_income_sources
            );

            const guarantorIncome = guarantorIncomeObj?.amount ?? 0; // ✅ FIXED

            // 🔹 Step A: guarantor-only effort rate
            const guarantorOnlyEffortRate =
              guarantorIncome > 0
                ? (getRentPercentage(guarantorIncome, rent)?.roundValue ?? 0)
                : 0;

            // 🔹 Step B: scoring
            const gTemp = await getFieldForPolicies(
              g,
              user,
              guarantorOnlyEffortRate,
              giveInsurance,
              deaWorkspace
            );

            const gScoreResult = await calculateFinalScore(
              customPolicyDetails.scoringConfig,
              customPolicyDetails.overlayConfig,
              customPolicyDetails.policyConfig,
              gTemp
            );

            const guarantorScore = gScoreResult?.finalScore ?? 0;
            const gErrors = Object.entries(gTemp).filter(
              ([_, value]) => value?.isHardFail === true
            );
            const label = getUserDisplayName(g);

            gTemp.label = label;
            g._localIncome = guarantorIncome;
            gScoreResult.errorEntries = gErrors;
            gScoreResult.isHardFail = gErrors?.length > 0;

            tempGuarantorResults[g?._id] = {
              ...gScoreResult,
              vals: gTemp,
              _id: g?._id,
              tenantData: {
                documentNumber: getIdentityDetails(g, g?.onfido_user_kyc)
                  ?.value,
                dob: tenantInfo?.dob,
                income: guarantorIncome,
              },
              label,
              isGuarantor: true,
              role: "guarantor",
            };

            // 🔹 Step C: weight
            let weight = 1;

            if (guarantorScore < 65) {
              weight = 0.6;
            } else if (guarantorScore <= 80) {
              weight = 0.75;
            }

            // 🔹 Custom hook
            const shouldUseGuarantorIncome = true;

            return shouldUseGuarantorIncome ? guarantorIncome * weight : 0;
          })
        );

        // 🔹 Final sum
        guarantorIncomeSum += guarantorResults.reduce(
          (sum, val) => sum + val,
          0
        );
      }

      const totalIncome = tenantIncomeSum + guarantorIncomeSum;

      // #NOTE: showing both tenants and guarantor's total combined incomes
      setToalCombinedIncome(totalIncome);

      const finalEffortRate =
        getRentPercentage(totalIncome, rent)?.roundValue ?? "0";

      const resultDea = [];
      const tempTenantResults = {};

      //   #NOTE: if the (selectedTenant) which is a sharedProfile is an application tyep
      // then we check if it is an application then we use each participant from the application

      const profiles = selectedTenant
        .flatMap((s) => {
          const application = s?.application_id;
          if (application?.participants?.length > 0) {
            return application?.participants.map((participant) => {
              return {
                ...s,
                tenantid: participant?.tenant_info,
              };
            });
          } else {
            return s;
          }
        })
        .filter((sp) => sp.tenantid);

      for (let entry of profiles) {
        console.log("entry", entry);
        if (runIdRef.current !== currentRunId) return;

        try {
          // ===== TENANT =====
          const temp = await getFieldForPolicies(
            entry?.tenantid,
            user,
            finalEffortRate,
            giveInsurance,
            deaWorkspace
          );

          if (runIdRef.current !== currentRunId) return;

          const DEA_SCORE = calculateOverlayScore(
            temp.EFFORT_RATE_SCORE,
            temp.TENURE,
            temp.EMPLOYMENT_PREDICTABILITY,
            temp.SECTOR_CYCLICALITY,
            temp.EMPLOYER_STABILITY
          );

          const errorEntries = Object.entries(temp).filter(
            ([_, value]) => value?.isHardFail === true
          );

          let guarantorOutsideSpain = false;
          const checkGuarantors = entry?.tenantid?.gurantor_id || [];
          for (let g of checkGuarantors) {
            const forensicData =
              g?.tenant_extra_field_id?.forensic_financial_data;
            if (forensicData) {
              for (let key in forensicData) {
                if (
                  forensicData[key]?.origin &&
                  forensicData[key]?.origin !== "Local"
                ) {
                  guarantorOutsideSpain = true;
                  break;
                }
              }
            }
            if (guarantorOutsideSpain) break;
          }
          if (guarantorOutsideSpain) {
            errorEntries.push([
              "GUARANTOR_OUTSIDE_SPAIN",
              { isHardFail: true, label: "guarantorLivingOutsideSpain" },
            ]);
          }

          // ===== GUARANTORS (NEW) =====
          const guarantors = entry?.tenantid?.gurantor_id || [];

          const guarantorResults = [];

          for (let g of guarantors) {
            const gTemp = await getFieldForPolicies(
              g,
              user,
              finalEffortRate,
              giveInsurance,
              deaWorkspace
            );

            const gScore = calculateOverlayScore(
              gTemp.EFFORT_RATE_SCORE,
              gTemp.TENURE,
              gTemp.EMPLOYMENT_PREDICTABILITY,
              gTemp.SECTOR_CYCLICALITY,
              gTemp.EMPLOYER_STABILITY
            );

            const gErrors = Object.entries(gTemp).filter(
              ([_, value]) => value?.isHardFail === true
            );

            guarantorResults.push({
              ...g,
              DEA_SCORE: gScore,
              errorEntries: gErrors,
              vals: gTemp,
            });
          }

          // ===== LABEL (UNCHANGED) =====
          const label = getUserDisplayName(entry?.tenantid);

          entry.tenantid.label = label;

          temp.EFFORT_RATE_SCORE = temp?.EFFORT_RATE_SCORE?.EFFORT_RATE_SCORE;
          // ===== PUSH (ONLY ADDITION = guarantors) =====
          resultDea.push({
            ...entry?.tenantid,
            DEA_SCORE,
            errorEntries,
            vals: temp,
            guarantors: guarantorResults, // ✅ NEW FIELD
          });
          // ===== EXISTING SCORING (UNCHANGED) =====
          const result = await calculateFinalScore(
            customPolicyDetails.scoringConfig,
            customPolicyDetails.overlayConfig,
            customPolicyDetails.policyConfig,
            temp
          );
          if (runIdRef.current !== currentRunId) return;

          result.errorEntries = errorEntries;
          result.isHardFail = errorEntries?.length > 0;
          const tenantId = entry?.tenantid?._id;
          const tenantReportData = {
            documentNumber: getIdentityDetails(
              entry?.tenantid,
              entry?.tenantid?.onfido_user_kyc
            )?.value,
            dob: entry?.tenantid?.dob,
            income: entry?.tenantid?._localIncome,
            displayEffortRate: getRentPercentage(
              entry?.tenantid?._localIncome,
              rent
            )?.roundValue,
          };
          tempTenantResults[tenantId] = {
            ...result,
            vals: temp,
            _id: tenantId,
            tenantData: tenantReportData,
            label: entry?.tenantid?.label,
          };
        } catch (err) {
          if (runIdRef.current !== currentRunId) return;
          console.error("Unexpected error:", err);
        }
      }
      setTenantResults(tempTenantResults);
      setGuarantorResults(tempGuarantorResults);
      setDeaResult(resultDea);
      setFinalEffortRate(finalEffortRate);
    } catch (err) {
      console.log(err);
    } finally {
      if (runIdRef.current === currentRunId) {
        setResultLoader(false);
      }
    }
  }

  const processAssignPropData = async () => {
    let tenantIncomeSum = 0;
    let guarantorIncomeSum = 0;

    const allEntires = getName();
    console.log("DEBUG allEntires", allEntires);
    const profiles = allEntires.flatMap((entry) => {
      console.log("DEBUG entry", entry);
      if (entry?.application_id?.participants?.length > 0) {
        return entry?.application_id?.participants.map((p) => ({
          ...entry,
          ...p,
          participantId: p?.tenant_info?._id,
          tenantid: p?.tenant_info,
        }));
      } else {
        return entry;
      }
    });

    console.log("DEBUG profiles", profiles);

    // ---- SAME INCOME LOGIC (UNCHANGED) ----
    for (let entry of profiles) {
      const incomeSelection = resolveIncomeSelection(
        entry?.income_selection,
        entry?.participantId ? entry?.participantId : entry?.tenantid?._id
        // entry?.tenantid?._id
      );
      const tenantInfo = entry?.tenantid;
      console.log("HERE", entry?.custom_income_sources, tenantInfo);

      const tenantIncome = getCustomIncomeDetails(
        tenantInfo,
        user,
        _t,
        incomeSelection?.tenant_source,
        undefined,
        undefined,
        deaWorkspace,
        entry?.custom_income_sources
      );

      tenantIncomeSum += tenantIncome?.amount ?? 0;

      const guarantors = tenantInfo?.gurantor_id || [];

      for (let g of guarantors) {
        const guarantorIncome = getCustomIncomeDetails(
          g,
          user,
          _t,
          incomeSelection?.guarantor_sources?.[g?._id],
          undefined,
          undefined,
          deaWorkspace,
          entry?.custom_income_sources
        );

        guarantorIncomeSum += guarantorIncome?.amount ?? 0;
      }
    }

    const totalIncome = tenantIncomeSum + guarantorIncomeSum;

    const finalEffortRate =
      getRentPercentage(totalIncome, rent)?.roundValue ?? "0";

    const resultDeaObject = {};

    // ---- PARALLEL PROCESSING (SAFE OPTIMIZATION) ----
    await Promise.all(
      allEntires.map(async (entry) => {
        try {
          // ===== TENANT (UNCHANGED LOGIC) =====
          const temp = await getFieldForPolicies(
            entry?.tenantid,
            user,
            finalEffortRate,
            giveInsurance,
            deaWorkspace
          );

          const DEA_SCORE = calculateOverlayScore(
            temp.EFFORT_RATE_SCORE,
            temp.TENURE,
            temp.EMPLOYMENT_PREDICTABILITY,
            temp.SECTOR_CYCLICALITY,
            temp.EMPLOYER_STABILITY
          );

          const errorEntries = Object.entries(temp).filter(
            ([key, value]) => value?.isHardFail === true
          );

          let guarantorOutsideSpain = false;
          const checkGuarantors = entry?.tenantid?.gurantor_id || [];
          for (let g of checkGuarantors) {
            const forensicData =
              g?.tenant_extra_field_id?.forensic_financial_data;
            if (forensicData) {
              for (let key in forensicData) {
                if (
                  forensicData[key]?.origin &&
                  forensicData[key]?.origin !== "Local"
                ) {
                  guarantorOutsideSpain = true;
                  break;
                }
              }
            }
            if (guarantorOutsideSpain) break;
          }
          if (guarantorOutsideSpain) {
            errorEntries.push([
              "GUARANTOR_OUTSIDE_SPAIN",
              { isHardFail: true, label: "guarantorLivingOutsideSpain" },
            ]);
          }

          // ===== GUARANTORS (NEW - NON BREAKING) =====
          const guarantors = entry?.tenantid?.gurantor_id || [];

          const guarantorResults = await Promise.all(
            guarantors.map(async (g) => {
              try {
                const gTemp = await getFieldForPolicies(
                  g,
                  user,
                  finalEffortRate,
                  giveInsurance,
                  deaWorkspace
                );

                const gScore = calculateOverlayScore(
                  gTemp.EFFORT_RATE_SCORE,
                  gTemp.TENURE,
                  gTemp.EMPLOYMENT_PREDICTABILITY,
                  gTemp.SECTOR_CYCLICALITY,
                  gTemp.EMPLOYER_STABILITY
                );

                const gErrors = Object.entries(gTemp).filter(
                  ([_, value]) => value?.isHardFail === true
                );

                return {
                  ...g,
                  DEA_SCORE: gScore,
                  errorEntries: gErrors,
                  vals: gTemp,
                };
              } catch (err) {
                console.error("Guarantor error:", err);
                return null;
              }
            })
          );

          // ===== LABEL (UNCHANGED) =====
          const label = getUserDisplayName(entry?.tenantid);

          entry.tenantid.label = label;

          temp.EFFORT_RATE_SCORE = temp?.EFFORT_RATE_SCORE?.EFFORT_RATE_SCORE;

          // ===== FINAL OBJECT (ONLY ADDITION) =====
          resultDeaObject[entry?._id] = {
            ...entry?.tenantid,
            DEA_SCORE,
            errorEntries,
            vals: temp,

            // ✅ ONLY NEW FIELD (safe)
            guarantors: guarantorResults?.filter(Boolean),
          };
        } catch (err) {
          console.error("Unexpected error:", err);
        }
      })
    );

    setAllDeaResult(resultDeaObject);
  };

  const handleChangeRent = (e) => {
    const value = e.target.value;

    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setRent(value);
      setPropertyRentError(false);
    }
  };

  const handleBlurRent = async () => {
    if (!rent) {
      setPropertyRentError(true);
      return;
    }
    await updatePropertyDetails(property?._id, {
      report_rent: rent ?? "",
    });
    loadData();
  };

  useEffect(() => {
    if (propertyShareProfiles?.length > 0) {
      setAllDeaResult({});
      processAssignPropData();
    }
  }, [propertyShareProfiles, rent]);

  useEffect(() => {
    if (isPropertyAwarded) {
      if (property?.current_application) {
        setPropertyAwardedSelectedTenant(
          propertyShareProfiles?.filter(
            (val) => val?.application_id?._id === property?.current_application
          )
        );
      } else {
        const tempArr = propertyShareProfiles?.filter((val) =>
          property?.current_tenant?.includes(val?.tenantid?._id)
        );
        setPropertyAwardedSelectedTenant(tempArr);
      }
    }
  }, [isPropertyAwarded, propertyShareProfiles, property]);

  const calculateRentAmount = (fullinfo) => {
    const user_income_sources = resolveIncomeSelection(
      fullinfo?.income_selection,
      fullinfo?.tenantid?._id
    );
    const gurantor_income_sources = user_income_sources?.guarantor_sources;
    const disabledIncomeSourcesIds = fullinfo?.excluded_income_source_ids ?? [];

    const tInfo = fullinfo?.tenantid;

    const user_income = getCustomIncomeDetails(
      tInfo,
      user,
      _t,
      user_income_sources?.tenant_source,
      undefined,
      undefined,
      deaWorkspace,
      fullinfo?.custom_income_sources
    );

    // gurantor's income
    let totalGurantorIncome = 0;
    let allGurantorIncomes = [];
    let allGurantors = tInfo?.gurantor_id;

    if (Array.isArray(allGurantors)) {
      allGurantors.forEach((gurantor) => {
        if (haveValue(gurantor)) {
          const income = getCustomIncomeDetails(
            gurantor,
            user,
            _t,
            gurantor_income_sources?.[gurantor?._id],
            undefined,
            undefined,
            deaWorkspace,
            fullinfo?.custom_income_sources
          );

          // if (!disabledIncomeSourcesIds?.includes(income?.all_sources?._id)) {
          totalGurantorIncome += income?.amount || 0;
          // }
          allGurantorIncomes.push(income);
        }
      });
    }

    // const userAmount = !disabledIncomeSourcesIds?.includes(
    //   user_income?.all_sources?._id
    // )
    //   ? +user_income?.amount
    //   : 0;
    const userAmount = +user_income?.amount;

    // const combinedIncome = userAmount + +totalGurantorIncome;

    // const data = {
    //   ...fullinfo,
    //   rent_percentage: 35,
    // };
    // let temp_obj = calculateEffortRate(combinedIncome, user, data);

    // return !Number.isNaN(temp_obj?.effort_amount)
    //   ? Math.round(Number(temp_obj.effort_amount))
    //   : 0;

    return getRentPercentage(userAmount, rent)?.roundValue;
  };

  const getTenantIncomeDetails = (fullinfo) => {
    return getCustomIncomeDetails(
      fullinfo?.tenantid,
      user,
      _t,
      resolveIncomeSelection(
        fullinfo?.income_selection,
        fullinfo?.tenantid?._id
      )?.tenant_source,
      undefined,
      undefined,
      deaWorkspace,
      fullinfo?.custom_income_sources
    );
  };

  const checkAllTenantsHaveAcceptedSharing = (tenants) => {
    if (!tenants || tenants.length === 0) return false;

    return tenants.every((tenant) => {
      const applicationId = tenant?.application_id;
      if (!applicationId) return true;

      const participants = applicationId?.participants || [];
      if (participants.length === 0) return true;

      return participants.every(
        (participant) => participant?.consent_status === "accepted"
      );
    });
  };

  const generateReport = async () => {
    if (!checkAllTenantsHaveAcceptedSharing(selectedTenant)) {
      toast.error(
        _t(
          "tenantSharingNotAccepted",
          "Cannot generate report. Tenant has not accepted sharing with landlord."
        )
      );
      return;
    }
    setAwardPopupModal(true);
  };

  const handleAwardPropFlow = async () => {
    if (!checkAllTenantsHaveAcceptedSharing(selectedTenant)) {
      toast.error(
        _t(
          "tenantSharingNotAccepted",
          "Cannot award property. Tenant has not accepted sharing with landlord."
        )
      );
      return;
    }

    setLoading(true);
    try {
      const applicationDetails = getApplicationDetails(selectedTenant[0]);

      let res;
      if (applicationDetails?.hasApplication) {
        const applicationId = selectedTenant[0]?.application_id?._id;
        const data = {
          property_id: property?._id,
          application_id: applicationId,
        };
        res = await awardApplicationToProperty(data);
        toast.success(
          _t(
            "successWhileAwardingMultiPropAdminWillContactYou",
            "Success text when LL tries to award Multi tenant prop"
          )
        );
      } else {
        res = await sendAwardPropEmail();
      }

      setShowSuccessPopup(true);
      if (setPropData) setPropData({});
      setSelectedTenant([]);
      setSuccessTenant(res?.data || res);
      onPropertyAward(property?._id);
    } catch (err) {
      toast.error(
        _t(
          "errorWhileAwardingMultiProp",
          "Error text when LL tries to award Multi tenant prop"
        )
      );
    } finally {
      setLoading(false);
    }
  };

  const clearExpiredLinkedReportCache = () => {
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (!key.startsWith(LINKED_REPORT_CACHE_PREFIX)) return;

        const cachedValue = JSON.parse(sessionStorage.getItem(key));
        if (!cachedValue?.expiresAt || cachedValue.expiresAt <= Date.now()) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.log("Unable to clear linked report cache", error);
    }
  };

  const handleGenerateLinkedReport = (reportCacheData = {}) => {
    if (!haveValue(selectedTenant) || selectedTenant.length === 0) {
      return;
    }

    if (!checkAllTenantsHaveAcceptedSharing(selectedTenant)) {
      toast.error(
        _t(
          "tenantSharingNotAccepted",
          "Cannot generate report. Tenant has not accepted sharing with landlord."
        )
      );
      return;
    }

    let queryParams = "";
    selectedTenant.forEach((tenantProfile) => {
      queryParams += `sharedprofileid=${tenantProfile?._id}&`;
    });

    queryParams += `rent=${rent || property?.report_rent || 0}`;

    if (haveValue(property?._id)) {
      queryParams += `&property=${property?._id}`;
    }

    const propertyName = `${property?.street || ""} ${
      Number.isNaN(parseInt(property?.street_number, 10))
        ? ""
        : String(parseInt(property?.street_number, 10))
    }${property?.floor_number ? `, ${property?.floor_number}` : ""}${
      property?.flat_number ? ` - ${property?.flat_number}` : ""
    }`.trim();

    if (haveValue(propertyName)) {
      queryParams += `&propName=${encodeURIComponent(propertyName)}`;
    }
    if (haveValue(property?.zip_code)) {
      queryParams += `&postalCode=${encodeURIComponent(property?.zip_code)}`;
    }
    if (haveValue(property?.city)) {
      queryParams += `&city=${encodeURIComponent(property?.city)}`;
    }

    const redirectUrl = window.location.pathname + window.location.search;
    queryParams += `&redirectUrl=${encodeURIComponent(redirectUrl)}`;

    try {
      clearExpiredLinkedReportCache();
      const reportStateKey = `${LINKED_REPORT_CACHE_PREFIX}${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`;
      const linkedReportState = {
        ...reportCacheData,
        addressVal: {
          ...property,
          postcode: property?.postcode ?? property?.zip_code,
          muncipality: property?.muncipality ?? property?.city,
        },
        rent: rent || property?.report_rent || 0,
        sharedProfileCount: selectedTenant?.length ?? 0,
        combinedIncome: totalCombinedIncome,
        combinedEffortRate:
          haveValue(finalEffortRate) && !Number.isNaN(Number(finalEffortRate))
            ? `${finalEffortRate}%`
            : "No data",
        reportInsurableStatus: simulationDidNotRun
          ? "simulationDidNotRun"
          : areAllSelectedTenantsInsurable && isInsuranceSimulationSuccess,
        areAllSelectedTenantsInsurable,
        expiresAt: Date.now() + LINKED_REPORT_CACHE_TTL_MS,
      };

      sessionStorage.setItem(reportStateKey, JSON.stringify(linkedReportState));
      queryParams += `&reportStateKey=${encodeURIComponent(reportStateKey)}`;
    } catch (error) {
      console.log("Unable to cache linked report data", error);
    }

    window.open(
      `${haveValue(workspaceId) ? `/${workspaceId}` : ""}/linked-report-overview?${queryParams}`,
      "_blank"
    );
    // navigate(
    //   `${haveValue(workspaceId) ? `/${workspaceId}` : ""}/linked-report-overview?${queryParams}`,
    //   { state: { riskReportData } },
    // );
  };

  const sendAwardPropEmail = async () => {
    const send_data = {
      selected_tenants: selectedTenant.map((val) => val?.tenantid),
      property_id: property?._id,
    };

    try {
      const res = await multiPropAward(send_data);
      toast.success(
        _t(
          "successWhileAwardingMultiPropAdminWillContactYou",
          "Success text when LL tries to award Multi tenant prop"
        )
      );
      return res.data;
    } catch (err) {
      toast.error(
        _t(
          "errorWhileAwardingMultiProp",
          "Error text when LL tries to award Multi tenant prop"
        )
      );
      console.log("Error while awarding MultiProp");
      return Error(err);
    }
  };

  const sendInvitationViaEmail = async (e) => {
    e.preventDefault();
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(sharerEmail)) {
      setSendInvitationLoading(true);
      try {
        const response = await sendInvitationToTenant({
          type: "email",
          name: sharerName,
          email: sharerEmail,
          property_id: property?._id,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharerEmail(null);
        setShowEmailModal(false);
        setSendInvitationLoading(false);
      }
    } else {
      toast.error(_t("invalidEmailAddress"));
      return false;
    }
  };

  const normalizeTenantEntry = (item) => {
    const applicationData = item?.application_id || item?.application;

    return {
      ...item,
      application_id: applicationData,
      tenantid: item?.tenantid || item?.tenant_id || item?.tenant,
    };
  };

  const getName = () => {
    if (haveValue(searchText)) {
      const searchLower = searchText.toLowerCase();

      const filtered = (tanentData ?? [])
        .map(normalizeTenantEntry)
        .filter((item) => {
          const participants = item?.application_id?.participants ?? [];

          const participantMatch = participants.some(
            (p) =>
              p?.email?.toLowerCase()?.includes(searchLower) ||
              p?.name?.toLowerCase()?.includes(searchLower) ||
              getUserDisplayName(p?.tenant_info)
                ?.toLowerCase()
                ?.includes(searchLower)
          );

          const itemMatch =
            item?.label?.toLowerCase()?.includes(searchLower) ||
            item?.sub_val?.toLowerCase()?.includes(searchLower) ||
            getUserDisplayName(item?.tenantid)
              ?.toLowerCase()
              ?.includes(searchLower);

          return participantMatch || itemMatch;
        });

      return filtered;
    }

    if (isPropertyAwarded) {
      if (
        property?.current_application &&
        propertyAwardedSelectedTenant?.length === 0
      ) {
        const applicationEntry = propertyShareProfiles?.find(
          (val) => val?.application_id?._id === property?.current_application
        );

        if (applicationEntry) {
          return [applicationEntry];
        }
      }

      return propertyAwardedSelectedTenant;
    }

    return propertyShareProfiles;
  };

  const getApplicationDetails = (profileEntry) => {
    const participants =
      profileEntry?.application_id?.participants?.map((p) => ({
        ...p,
        isPrimary: p?.id === profileEntry?.application_id?.created_by,
      })) ?? [];
    const acceptedParticipants = participants.filter(
      (participant) =>
        participant?.consent_status === "accepted" && participant?.tenant_info
    );
    const applicationMembers = acceptedParticipants
      .map((participant) =>
        participant?.name
          ? participant?.name
          : getUserDisplayName(participant?.tenant_info)
      )
      .filter(Boolean);
    const primaryParticipant =
      participants.find(
        (participant) =>
          participant?.id === profileEntry?.application_id?.created_by
      )?.tenant_info ?? acceptedParticipants?.[0]?.tenant_info;

    return {
      applicationId: profileEntry?.application_id?._id,
      title: profileEntry?.application_id?.title,
      participants,
      acceptedParticipants,
      primaryName: primaryParticipant
        ? getUserDisplayName(primaryParticipant)
        : primaryParticipant?.name,
      subtitleMembers: applicationMembers.slice(1, 3).join(", "),
      hasMoreMembers: applicationMembers.length > 3,
      hasApplication: participants.length > 0,
    };
  };

  const toggleApplicationAccordion = (sharedProfileId) => {
    setOpenApplicationIds((prev) => ({
      ...prev,
      [sharedProfileId]: !prev?.[sharedProfileId],
    }));
  };

  const handleCheckboxChange = (tenantData) => (e) => {
    const isChecked = e.target.checked;
    setGiveInsurance(false);
    setShowRiskAssessmentReportModal(false);
    setSelectedTenant((prev) => {
      if (isChecked) {
        return [...prev, tenantData];
      } else {
        return prev.filter((tenant) => tenant._id !== tenantData._id);
      }
    });
  };

  const getTenantId = (tenantData) =>
    tenantData?.tenantid?._id || tenantData?.value;

  const getTrackingId = (tenantData) => {
    const applicationId = tenantData?.application_id?._id;
    const tenantId = tenantData?.tenantid?._id || tenantData?.value;
    return applicationId ? applicationId : tenantId;
  };

  const handleTenantSelect = async (tenantData, selectStatus) => {
    const trackingId = getTrackingId(tenantData);
    setLinkingTenantIds((prev) => [...prev, trackingId]);
    setEnabled(false);

    try {
      const applicationDetails = getApplicationDetails(tenantData);
      if (applicationDetails?.hasApplication) {
        if (selectStatus === "notSelected") {
          await editSharedProfile(tenantData._id, {
            property_id: property?._id,
            status: "add",
          });
        } else {
          await editSharedProfile(tenantData._id, {
            property_id: property?._id,
            status: "remove",
          });
        }
        await fetchShareProfileData(true, true);
      } else {
        const tenantId = getTenantId(tenantData);
        const updatedList =
          selectStatus === "notSelected"
            ? [...selectedTanents, tenantId]
            : selectedTanents.filter((val) => val !== tenantId);

        setSelectedTanents(updatedList);
        await handleSaveChanges(null, updatedList);
        await fetchShareProfileData(false, false);
      }
    } catch (error) {
      console.error("Error linking/unlinking tenant:", error);
    } finally {
      setLinkingTenantIds((prev) => prev.filter((id) => id !== trackingId));
    }
  };

  const handleUnLinkSingle = async (e, tenantData) => {
    const trackingId = getTrackingId(tenantData);

    setUnlinkingTenantIds((prev) => [...prev, trackingId]);
    setEnabled(false);

    try {
      const applicationDetails = getApplicationDetails(tenantData);

      if (applicationDetails?.hasApplication) {
        await unlinkApplicationFromProperty({
          property_id: property?._id,
          application_id: applicationDetails?.applicationId,
        });
        await fetchShareProfileData(true, true);
      } else {
        const tenantId = getTenantId(tenantData);
        const temp = selectedTanents.filter((val) => val !== tenantId);
        setSelectedTanents(temp);
        await handleSaveChanges(e, temp);
        await fetchShareProfileData(false, true);
      }
    } catch (error) {
      console.error("Error unlinking tenant:", error);
      toast.error(
        _t("errorWhileUnlinkingTenant", "Error while unlinking tenant")
      );
    } finally {
      setUnlinkingTenantIds((prev) => prev.filter((id) => id !== trackingId));
    }
  };

  const handleUnAwardProperty = () => {
    setLoading(true);
    const send_data = {
      property_id: property?._id,
    };
    multiPropUnAward(send_data)
      .then((res) => {
        onPropertyAward(property?._id);
        setShowUnAwardSuccessPopup(true);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOpenProfile = async (profile) => {
    const isProfilePending = checkIsProfilePending(
      profile?.tenantid ?? profile?.tenant_id,
      profile?._id
    );

    if (isProfilePending) {
      return;
    }

    setLoading(true);
    try {
      const checkView = await shouldDeductNextView(user, profile?._id);

      if (checkView) {
        setCurrentProfile(profile);
        setServingPromptModalURL("");
        setServingPromptModal(true);
      } else {
        const params = new URLSearchParams(window.location.search);
        params.set("propertyId", property?._id);

        const propertyName = formatPropertyAddress(property, currentLang);

        params.set("propName", propertyName);
        const updatedUrl = `/${workspaceId}/home?${params.toString()}`;
        window.history.replaceState(null, "", updatedUrl);

        navigate(
          `/${workspaceId}/profile-property?sharedprofileid=${profile?._id}`,
          {
            state: { from: updatedUrl },
          }
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenParticipantProfile = async (participant, sharedProfileId) => {
    const tenantId = participant?.tenant_info?._id;
    if (!tenantId || !sharedProfileId) {
      return;
    }
    setLoading(true);
    try {
      const checkView = await shouldDeductNextView(
        user,
        sharedProfileId,
        tenantId
      );
      if (checkView) {
        setCurrentProfile({ _id: sharedProfileId });
        setServingPromptModalURL(
          `/${workspaceId}/profile-property?sharedprofileid=${sharedProfileId}&tenant_id=${tenantId}`
        );
        setServingPromptModal(true);
      } else {
        const params = new URLSearchParams(window.location.search);
        params.set("propertyId", property?._id);

        const propertyName = formatPropertyAddress(property, currentLang);

        params.set("propName", propertyName);
        const updatedUrl = `/${workspaceId}/home?${params.toString()}`;
        window.history.replaceState(null, "", updatedUrl);

        navigate(
          `/${workspaceId}/profile-property?sharedprofileid=${sharedProfileId}&tenant_id=${tenantId}`,
          {
            state: { from: updatedUrl },
          }
        );
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const areAllSelectedTenantsInsurable = useMemo(() => {
    const tenantsForInsurance = isPropertyAwarded
      ? propertyAwardedSelectedTenant
      : selectedTenant;
    if (!tenantsForInsurance || tenantsForInsurance.length === 0) {
      return false;
    }

    return tenantsForInsurance.every((tenant) => {
      const experianData =
        tenant?.tenantid?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.[
          "s:Body"
        ]?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

      return !isDefaulter(experianData);
    });
  }, [selectedTenant, propertyAwardedSelectedTenant, isPropertyAwarded]);

  const areAllSelectedTenantsHaveClearedAmlChecks = useMemo(() => {
    if (!selectedTenant || selectedTenant.length === 0) {
      return false;
    }

    return selectedTenant.some((tenant) => {
      if (
        !haveValue(
          tenant?.tenantid?.onfido_user_kyc?.onfido_workflow_res?.object?.status
        )
      ) {
        return false;
      }
      return !amlKycChecks(tenant?.tenantid);
    });
  }, [selectedTenant]);

  const isApplicationSelected = useMemo(() => {
    return selectedTenant?.some(
      (t) => getApplicationDetails(t)?.hasApplication === true
    );
  }, [selectedTenant]);

  const getStatusStyle = () => {
    let finalStatus = null;
    if (selectedTenant?.length === 0) {
      finalStatus = STATUS_STYLES.grey;
    } else if (!areAllSelectedTenantsInsurable) {
      finalStatus = STATUS_STYLES.red;
    } else if (areAllSelectedTenantsHaveClearedAmlChecks) {
      finalStatus = STATUS_STYLES.yellow;
    } else {
      finalStatus = STATUS_STYLES.green;
    }
    setStatusStyle(finalStatus);
  };

  const checkInsuranceDocument = async () => {
    try {
      setCheckStatusLoading(true);
      const docStatusResponse = await checkInsuranceDocumentStatus(
        property?._id
      );

      if (haveValue(docStatusResponse?.policyDocument)) {
        await loadData();
        toast.success(_t("policyIsAvailableToDownlaod"));
      } else {
        toast.success(_t("insuranceIsInProcessPleaseWait"));
      }
    } catch (error) {
      toast.error(_t("failedToLoadStatus"));
    } finally {
      setCheckStatusLoading(false);
    }
  };

  const isInsurableEnabledLandlord = user?.insurance_service_status;

  const hasMissingPropertyDetails =
    !property?.province ||
    !property?.muncipality ||
    !property?.postcode ||
    !property?.street ||
    !property?.street_number;

  const getSimulationCacheKey = (tenants, rentVal) => {
    const sortedIds = tenants
      .map((t) => t?.tenantid?._id)
      .filter(Boolean)
      .sort()
      .join(",");
    return `${sortedIds}__${rentVal}`;
  };

  // Insurance Handler starts
  const runInsuranceSimulationHandler = async (
    usedFor,
    isAwardFlow = false
  ) => {
    const isRiskAssessment = usedFor === "risk-assessment";
    if (!areAllSelectedTenantsInsurable) {
      return;
    }

    if (isAwardFlow) {
      setAwardInsuranceSimulationLoading(true);
    }

    const cacheKey = getSimulationCacheKey(selectedTenant, rent);
    const cached = simulationCacheRef.current[cacheKey];
    if (cached && cacheKey === lastSimulationKeyRef.current) {
      const { isInsurable, insuranceCost, preFilledDocument } = cached;
      setIsInsuranceSimulationSuccess(isInsurable);
      setSimulatedInsuranceCost(insuranceCost ?? null);
      setPreFilledInsuranceDocument(preFilledDocument ?? null);
      setSimulationDidNotRun(false);
      setSimulationPropertyErrors([]);
      setSimulationConsentErrors([]);
      if (!isRiskAssessment) {
        setShowAwardInsurancePopup(true);
      }
      setAwardInsuranceSimulationLoading(false);
      return;
    }

    const propertyErrors = [];

    try {
      if (!isRiskAssessment) {
        setSimulationLoading(true);
      }
      setIsInsuranceSimulationSuccess(false);
      setInsuranceSimulationErrors([]);
      setSimulationPropertyErrors([]);
      setSimulationConsentErrors([]);
      setSimulationDidNotRun(false);

      if (!property?.province) {
        propertyErrors.push(_t("province"));
      }
      if (!property?.muncipality) {
        propertyErrors.push(_t("municipality"));
      }
      if (!property?.postcode) {
        propertyErrors.push(_t("postCode"));
      }
      if (!property?.street) {
        propertyErrors.push(_t("streetName"));
      }
      if (!property?.street_number) {
        propertyErrors.push(_t("streetNumber"));
      }

      if (propertyErrors.length > 0) {
        setSimulationPropertyErrors(propertyErrors);
        setInsuranceSimulationErrors(propertyErrors);
        if (!isRiskAssessment) {
          setInsuranceSimulationErrorModal("property");
          setSimulationLoading(false);
          setSimulationDidNotRun(true);
          if (isAwardFlow) {
            setAwardInsuranceSimulationLoading(false);
          }
          return;
        }
      }

      const errors = [];

      const tenantIds = selectedTenant
        .map((t) => t?.tenantid?._id)
        .filter(Boolean);

      const checkConsentResponse = await checkMutuaConsents(tenantIds);
      if (checkConsentResponse?.missingConsent?.length) {
        errors.push(
          ...checkConsentResponse.missingConsent.map(
            (t) => `${t.name} ${_t("hasMissingGrupoMutuaConsent")}`
          )
        );
      }

      if (errors.length > 0) {
        setSimulationConsentErrors(errors);
        setSimulationDidNotRun(true);
        if (!isRiskAssessment) {
          setInsuranceSimulationErrorModal(true);
          setInsuranceSimulationErrors(errors);
          setSimulationLoading(false);
          if (isAwardFlow) {
            setAwardInsuranceSimulationLoading(false);
          }
        }
        console.log(
          "Simulation not processed due to following errors:",
          errors
        );
        return;
      }

      setSimulationLoading(true);

      const payload = {
        propertyId: property?._id,
        property_rent: rent,
        lease_start_date: moment().format("DD/MM/YYYY"),
        policy_start_date: moment().format("DD/MM/YYYY"),
        selected_tenants: selectedTenant.map((t) => t?.tenantid?._id),
      };
      const simulationResponse = await runInsuranceSimulation(payload);

      const isInsurable = simulationResponse?.success_res?.isInsurable;
      const insuranceCost =
        simulationResponse?.success_res?.insuranceCost ?? null;
      const preFilledDocument = isInsurable
        ? (simulationResponse?.success_res?.pre_filled_insurance_document ??
          null)
        : null;

      simulationCacheRef.current[cacheKey] = {
        isInsurable,
        insuranceCost,
        preFilledDocument,
      };
      lastSimulationKeyRef.current = cacheKey;
      setSimulatedInsuranceCost(insuranceCost);
      setPreFilledInsuranceDocument(preFilledDocument);

      if (isInsurable) {
        if (!isRiskAssessment) {
          // setInsuracePopupModal(true);
          setShowAwardInsurancePopup(true);
        }
        setIsInsuranceSimulationSuccess(true);
      } else if (!isRiskAssessment) {
        setShowAwardInsurancePopup(true);
      }
      setSimulationDidNotRun(false);
    } catch (error) {
      console.log("Failed in runInsuranceSimulation", error);
      toast.error(_t("failedToRunInsuranceSimulation"));
    } finally {
      setSimulationLoading(false);
      if (isAwardFlow) {
        setAwardInsuranceSimulationLoading(false);
      }
    }
  };

  console.log("insuranceSimulationErrors", insuranceSimulationErrors);
  // Insurance Handler ends

  /**
   * Thin wrapper around the pure `computeFinalResult` utility.
   *
   * All business logic lives in src/utils/computeFinalResult.js so it can be
   * imported and tested independently. This wrapper simply:
   *   1. Forwards the current component state as parameters.
   *   2. Applies the returned `sideEffects` to the component's state setters.
   *   3. Returns the `result` (report payload or null) as before.
   */
  const renderFinalResult = (isReport = false) => {
    if (!checkAllTenantsHaveAcceptedSharing(selectedTenant)) {
      const now = Date.now();
      if (!lastToastTime || now - lastToastTime > TOAST_BUFFER_MS) {
        toast.error(
          _t(
            "tenantSharingNotAccepted",
            "Cannot generate report. Tenant has not accepted sharing with landlord."
          )
        );
        setLastToastTime(now);
      }
      return;
    }
    const { result, sideEffects } = computeFinalResult({
      tenantResults,
      selectedTenant,
      customPolicyDetails,
      giveInsurance,
      finalEffortRate,
      enabled,
      deaWorkspace,
      user,
      lastVerdict,
      lastRecommendationFlags,
      STATUS_STYLES,
      translate: _t,
      isReport,
      guarantorResults,
    });

    // Apply side-effects returned by the pure function
    try {
      if (sideEffects.nextStatusStyle !== null) {
        setStatusStyle((prev) =>
          prev === sideEffects.nextStatusStyle
            ? prev
            : sideEffects.nextStatusStyle
        );
      }
    } catch (e) {}

    try {
      if (sideEffects.verdict !== null) setLastVerdict(sideEffects.verdict);
    } catch (e) {}

    try {
      if (sideEffects.recommendationFlags !== null)
        setLastRecommendationFlags(sideEffects.recommendationFlags);
    } catch (e) {}

    try {
      if (sideEffects.showAddGuarantor !== null)
        setLastShowAddGuarantor(sideEffects.showAddGuarantor);
    } catch (e) {}

    return result;
  };

  const renderIndividualDeaResult = (id) => {
    if (haveValue(id)) {
      const data = allDeaResult?.[id];
      const profilesHaveMissingDocs = data?.vals?.DOCUMENTATION > 0;

      const hasHardFailEntries =
        data?.errorEntries?.filter(([key]) => key !== "EFFORT_RATE_SCORE")
          ?.length > 0;

      // ✅ NEW (safe optional checks)
      const guarantors = data?.guarantors || [];

      const guarantorHasHardFail = guarantors.some(
        (g) =>
          g?.errorEntries?.filter(([key]) => key !== "EFFORT_RATE_SCORE")
            ?.length > 0
      );

      const guarantorMissingDocs = guarantors.some(
        (g) => g?.vals?.DOCUMENTATION > 0
      );

      // 🔴 unchanged logic + guarantor extension
      if (hasHardFailEntries || guarantorHasHardFail) {
        return STATUS_STYLES.red;
      } else if (!profilesHaveMissingDocs && !guarantorMissingDocs) {
        return STATUS_STYLES.green;
      } else {
        return STATUS_STYLES.yellow;
      }
    }
  };

  const EligibilityCard = (props) => {
    const { _t } = useTranslator();
    return (
      <div
        className={`eligibility-box d-flex flex-column gap-8px mb-2 ${props.status}`}
      >
        <div className="d-flex gap-6px align-items-center justify-content-between heading-wrapper">
          <div className="d-flex gap-6px align-items-center">
            {props.status === "conditional" ? (
              <img
                src="/images/warning.svg"
                alt="warning-icon"
                className="heading-icon"
              />
            ) : props.status === "rejected" ? (
              <img
                src="/images/notApproved.svg"
                alt="warning-icon"
                className="heading-icon"
              />
            ) : (
              <CheckIcon />
            )}
            <h3>{props.title}</h3>
          </div>
          {/* {Object?.entries(tenantResults)?.length > 0 && ( */}
          {props.status !== "rejected" && (
            <a
              onClick={(e) => {
                e.preventDefault();
                const generatedReport = renderFinalResult(true);
                setRiskReportData(generatedReport);
                setShowRiskAssessmentReportModal(true);
              }}
              className="cursor-pointer underline"
              style={{ fontSize: "0.972vw", fontWeight: "500" }}
            >
              {_t("viewDetails")}
            </a>
          )}
          {/* )} */}
        </div>

        <p className="eligibility-description">{props.description}</p>

        {props.lowEffortRate && !props.errorReasons?.length && !enabled && (
          <div className="d-flex align-items-center gap-6px">
            <span className="dot-low-effort-rate" />
            <p>
              {props.lowEffortRate.name} — {props.lowEffortRate.reason}
            </p>
          </div>
        )}

        {props.errorReasons?.length > 0 && !enabled ? (
          <div className="d-flex flex-column gap-6px">
            {props.errorReasons.map((errorReason) => (
              <div
                key={errorReason.id}
                className="d-flex align-items-center gap-6px"
              >
                <span className="dot-low-effort-rate" />
                <p>
                  {errorReason.name} — {errorReason.reason}
                </p>
              </div>
            ))}
          </div>
        ) : (
          ""
        )}

        {props.showCompleteProfile && (
          <div className="add-guarantor-wrapper d-flex align-items-center gap-6px">
            <DocIcon
              className={props.status === "rejected" ? "error-icon" : ""}
            />
            <p>
              {_t(
                "requestDocumentUploadFromTenant",
                "Shown in recommendation engine when profile is incomplete"
              )}{" "}
            </p>
          </div>
        )}

        {props.showActions && props.status !== "approved" && (
          <p className="add-guarantor-wrapper">
            {_t("recommendedActionBasedOnCurrentData")}
          </p>
        )}
        {props.showActions && (
          <div className="d-flex gap-8px">
            {props.showAddGuarantor && !enabled ? (
              <>
                <div className="d-flex align-items-center gap-6px">
                  {/* <span className="number-circle d-flex align-items-center justify-content-center">
                    1
                  </span> */}
                  <p className="add-guarantor-title add-guarantor-tag">
                    {props.addGuarantorText || "Add Guarantor"}
                  </p>
                  {/* <span className="add-guarantor-strengthen">
                    -{" "}
                    {_t(
                      "strengthenApplication",
                      "Shown in recommendation engine for guarantor addition suggestion"
                    )}
                  </span> */}
                </div>

                {props.showInsurance && !enabled && (
                  <div className="d-flex align-items-center gap-6px">
                    <span className="border-1" />
                    <span className="add-guarantor-strengthen">{_t("or")}</span>
                    <span className="border-1" />
                  </div>
                )}
              </>
            ) : (
              ""
            )}

            {props.showInsurance && (
              <div
                className={`d-flex align-items-center gap-6px justify-content-between ${props.status === "approved" ? "add-guarantor-wrapper" : ""}`}
              >
                <div className="d-flex align-items-center gap-6px">
                  {props.status === "approved" ? (
                    <ShieldIcon />
                  ) : (
                    ""
                    // <span
                    //   className="number-circle d-flex align-items-center justify-content-center"
                    //   style={{
                    //     background: "#87c71a33",
                    //     color: "#87c71a",
                    //   }}
                    // >
                    //   {props.showAddGuarantor ? 2 : 1}
                    // </span>
                  )}
                  {enabled && (
                    <p className="add-guarantor-title">
                      {_t("skorInsuranceEnabled")}
                    </p>
                  )}
                </div>
                <div
                  className={`toggle-wrapper-switch ${enabled ? "toggle-wrapper-switch--active" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setEnabled((prev) => !prev);
                  }}
                  role="switch"
                  aria-checked={enabled}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setEnabled((prev) => !prev);
                    }
                  }}
                >
                  <div className="track">
                    <div className="knob" />
                  </div>
                  <span className="label">{_t("enableSkorInsurance")}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {showRiskAssessmentReportModal ? (
        <RiskAssessmentReport
          onClose={handleCloseRiskAssessmentReportModal}
          selectedTenants={selectedTenant}
          reportData={riskReportData}
          enabled={enabled}
          finalEffortRate={finalEffortRate}
          areAllSelectedTenantsInsurable={areAllSelectedTenantsInsurable}
          setEnabled={setEnabled}
          totalCombinedIncome={totalCombinedIncome}
          handleGenerateLinkedReport={handleGenerateLinkedReport}
          isInsurableEnabledLandlord={isInsurableEnabledLandlord}
          runInsuranceSimulationHandler={runInsuranceSimulationHandler}
          simulationLoading={simulationLoading}
          insuracePopupModal={insuracePopupModal}
          isInsuranceSimulationSuccess={isInsuranceSimulationSuccess}
          simulationDidNotRun={simulationDidNotRun}
          simulationPropertyErrors={simulationPropertyErrors}
          simulationConsentErrors={simulationConsentErrors}
          onEditProperty={onEditProperty}
          preFilledInsuranceDocument={preFilledInsuranceDocument}
        />
      ) : null}
      {detailsShow && (
        <div
          className="metermodal modal-xl wrapper-modal modalWidth_set"
          onClick={() => {
            setDetailsShow(false);
            if (setPropData) setPropData({});
            // setSelectedTenant([]);
            handleCloseRiskAssessmentReportModal();
          }}
        >
          <div
            className={`doc-history-popup rental-overview-popup total-salary-modal share-profile-modal sharedTenantProfileModal ${
              detailsShow ? "open" : ""
            }`}
            onClick={(e) => {
              setIsDownloadDocList(false);
              e.stopPropagation();
            }}
          >
            <div className="doc-history-header linked-property-popup-padding">
              <div className="d-flex align-items-center custom-gap-2">
                <img
                  src={CloseIcon}
                  alt=""
                  className="doc-history-close-btn"
                  onClick={() => {
                    setDetailsShow(false);
                    if (setPropData) setPropData({});
                    handleCloseRiskAssessmentReportModal();
                    // setSelectedTenant([]);
                  }}
                />
                <h4 className="custom-modal-heading">{_t("rentalOverview")}</h4>
              </div>
            </div>
            <div className="rental-overview-scroll tenant-overview-scroll">
              {/* <div className="assigned_details_body">
                <p className="linked_p_details linked-property-sub-heading">
                  {_t("propertyTitle")}
                </p>
              </div> */}
              <div className="rental-property-summary">
                <div className="rental-property-info">
                  <div className="rental-property-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M10.7068 0.29279L19.7051 9.29291C20.335 9.92291 19.889 10.9999 18.9982 10.9999H17.9984V16.9999C17.9984 17.7956 17.6824 18.5587 17.1199 19.1213C16.5574 19.6839 15.7945 20 14.9989 20H13.9992V12.9999C13.9992 12.2347 13.7069 11.4984 13.182 10.9416C12.6572 10.3849 11.9394 10.0498 11.1756 10.0049L10.9997 9.99988H9.00005C8.20458 9.99988 7.44164 10.3159 6.87917 10.8786C6.31664 11.4412 6.00064 12.2042 6.00064 12.9999V20H5.00082C4.20531 20 3.4424 19.6839 2.87989 19.1213C2.31739 18.5587 2.00137 17.7956 2.00137 16.9999V10.9999H1.00156C0.111727 10.9999 -0.33519 9.92291 0.294693 9.29291L9.29299 0.29279C9.48052 0.105316 9.73476 0 9.99987 0C10.265 0 10.5193 0.105316 10.7068 0.29279ZM10.9997 11.9999C11.2649 11.9999 11.5192 12.1053 11.7067 12.2928C11.8942 12.4804 11.9995 12.7347 11.9995 12.9999V20H8.00029V12.9999C8.00029 12.755 8.09017 12.5186 8.25293 12.3356C8.41564 12.1525 8.63988 12.0356 8.88311 12.0069L9.00005 11.9999H10.9997Z"
                        fill="#253837"
                      />
                    </svg>
                  </div>

                  <div className="rental-property-text">
                    <h3>{formatPropertyAddress(property, currentLang)}</h3>
                    <p>
                      {[property?.province, property?.postcode]
                        .filter(Boolean)
                        .join(", ")}
                    </p>
                  </div>
                </div>

                <div className="rental-rent-card">
                  <span className="rental-rent-label">
                    {_t("propertyRent")}
                  </span>

                  <div
                    className={`rental-rent-input ${
                      propertyRentError ? "property-validation-error" : ""
                    }`}
                  >
                    <span className="rental-currency">€</span>
                    <input
                      placeholder="0"
                      type="number"
                      value={rent}
                      disabled={isPropertyAwarded || simulationLoading}
                      onChange={handleChangeRent}
                      onBlur={handleBlurRent}
                    />
                    <span className="rental-period">/mo</span>
                  </div>

                  {propertyRentError && (
                    <p className="error-message">
                      {_t("pleaseEnterTheRentToProceed")}
                    </p>
                  )}
                </div>
              </div>
              {hasMissingPropertyDetails && (
                <div
                  className="d-flex align-items-center gap-1 cursor-pointer missing-property-details"
                  onClick={() => onEditProperty?.()}
                >
                  <p style={{ color: "#AD3300", margin: 0 }}>
                    {_t("missingPropertyDetails", "Missing property details")}
                  </p>
                  <PencilEditIcon />
                </div>
              )}
              <div className="assigned_details_body d-flex justify-content-between align-items-center heading-tenant-wrapper">
                <p className="linked_p_details linked-property-sub-heading">
                  {_t("tenants")}
                </p>
              </div>
              {isInsurableEnabledLandlord && (
                <>
                  {isInsuranceEnabledWorkspace &&
                    isPropertyAwarded &&
                    (haveValue(property?.insurance_data?.policy_document) &&
                    property?.insurance_data?.status === "confirmed" ? (
                      <div
                        className="insurance-policy-card"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="insurance-policy-left">
                          <div className="insurance-policy-icon-circle">
                            <OutlineShieldIcon />
                          </div>
                          <div className="insurance-policy-info">
                            <h1>{_t("nonPaymentInsurance")}</h1>
                            <p>
                              {[
                                property?.insurance_data?.simulationPayload
                                  ?.fechaEfectoPoliza &&
                                  moment(
                                    property.insurance_data.fechaEfectoPoliza
                                  ).format("DD/MM/YYYY"),

                                property?.insurance_data?.simulationPayload
                                  ?.fechaEfectoPoliza &&
                                  moment(
                                    property.insurance_data.fechaEfectoPoliza
                                  )
                                    .add(1, "year")
                                    .format("DD/MM/YYYY"),

                                property?.insurance_data?.payment_amount &&
                                  `€${property.insurance_data.payment_amount}/${_t("mo")}`,
                              ]
                                .filter(Boolean)
                                .join(" · ")}
                            </p>
                          </div>
                        </div>
                        <div className="insurance-policy-right">
                          <span className="insurance-active-badge">
                            {_t("active")}
                          </span>
                          <div className="position-relative">
                            <button
                              className="download-list-btn d-flex align-items-center justify-content-center"
                              onClick={() =>
                                setIsDownloadDocList(!isDownloadDocList)
                              }
                            >
                              <DownloadIcon />
                            </button>
                            {isDownloadDocList && (
                              <div className="download-doc-list-dropdown">
                                {[
                                  {
                                    label: _t("policyDocument"),
                                    file: property?.insurance_data
                                      ?.policy_document,
                                  },
                                  {
                                    label: _t("invoice"),
                                    file: property?.insurance_data
                                      ?.invoice_document,
                                  },
                                ].map((item, index) => (
                                  <button
                                    key={index}
                                    className="d-flex align-items-center gap-2"
                                    onClick={() => {
                                      if (item.file) {
                                        window.open(
                                          `${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${item.file}`,
                                          "_blank"
                                        );
                                      }
                                    }}
                                  >
                                    <img
                                      src="/images/docIconGreen.svg"
                                      alt="Doc"
                                    />
                                    {item.label}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : property?.insurance_data?.status === "failed" ? (
                      <div className="non-payment-container">
                        <div className="non-payment-container-info">
                          <img
                            src={"/images/non-payment-insurance.svg"}
                            alt=""
                          />

                          <div>
                            <h1>{_t("failedToProcessInsurance")}</h1>

                            <p>
                              <a
                                href="https://wa.me/34617662602"
                                target="_blank"
                                rel="noreferrer"
                              >
                                {_t("chatWithSupport")}
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : haveValue(
                        property?.insurance_data?.insurancePayload
                      ) ? (
                      <div className="insurance-policy-card">
                        <div className="insurance-policy-left">
                          <div className="insurance-policy-icon-circle">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#253837"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06" />
                              <path d="M15 19l2 2l4 -4" />
                            </svg>
                          </div>
                          <div className="insurance-policy-info">
                            <h1>{_t("nonPaymentInsurance")}</h1>
                            <p>{_t("processingInsurance")}</p>
                          </div>
                        </div>
                        <div className="insurance-policy-right">
                          <div className="ins-policy-processing-spinner" />
                        </div>
                      </div>
                    ) : null)}
                </>
              )}
              {/* Direct button to purchase insurance */}
              {/* purposely adding false because this div is not needed */}
              {user?.email === "invinte_b2c_tenants@yopmail.com" &&
                isInsuranceEnabledWorkspace &&
                selectedTenant.length > 0 &&
                WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                  user?.current_workspace_role
                ) &&
                (areAllSelectedTenantsInsurable ? (
                  <div
                    className="non-payment-container cursor-pointer"
                    onClick={() => {
                      if (
                        simulationLoading ||
                        !areAllSelectedTenantsInsurable ||
                        !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                          user?.current_workspace_role
                        )
                      ) {
                        console.log("Not allowed");
                      } else {
                        if (!haveValue(rent)) {
                          setPropertyRentError(true);
                        } else {
                          runInsuranceSimulationHandler();
                        }
                      }
                    }}
                  >
                    <div className="non-payment-container-info">
                      <img src={"/images/non-payment-insurance.svg"} alt="" />
                      <div>
                        <h1>
                          {_t(
                            simulationLoading
                              ? "analysingFeasibility"
                              : "getNonPaymentInsurance"
                          )}
                        </h1>
                        {!simulationLoading && (
                          <p>{_t("protectYourRentAgainstDefaultingTenants")}</p>
                        )}
                        <span>
                          <a
                            href="/pdf/Mom_seguroimpagoalquiler.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            {_t("insurancePolicy")}
                          </a>
                        </span>
                      </div>
                    </div>
                    <img
                      className="arrow-right cursor-pointer"
                      src={
                        simulationLoading
                          ? SkorDefaultLoader
                          : "/images/arrow-right.svg"
                      }
                      alt=""
                    />
                  </div>
                ) : (
                  <div
                    style={{ borderColor: "#EEEEF3", backgroundColor: "white" }}
                    className="non-payment-container"
                  >
                    <div className="non-payment-container-info">
                      <img src={"/images/insurance-not.svg"} alt="" />
                      <div>
                        <h1 style={{ color: "#7F7F7F" }}>
                          {_t("insuranceNotAvailable")}
                        </h1>
                        <p>{_t("someSelectedTenantsAreNotInsurable")}</p>
                      </div>
                    </div>
                  </div>
                ))}

              {/* {selectedTenant?.length > 0 &&
                !(
                  isDeaRulesActivated
                ) &&
                (resultLoader ? (
                  <div className="d-flex justify-content-center">
                    <img
                      src={SkorDefaultLoader}
                      className="defaultSkorLoader"
                    />
                  </div>
                ) : (
                  finalRenderedResult
                ))} */}
              {!isPropertyAwarded && (
                <div className="profile-page marless tab-profile-search-header w-100">
                  <div className="Search-bar searchbar_cls w-100 d-flex justify-content-between align-items-center">
                    {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                      user?.current_workspace_role
                    ) && (
                      <div className="search_bar_edit">
                        <a href="#">
                          <img src={"/images/search-icon-grey.svg"} alt="" />
                        </a>
                        <input
                          type="text"
                          className="custom-input mb-0 input01"
                          value={searchText}
                          placeholder={_t("searchTenants")}
                          onChange={(e) => {
                            // if (e.target.value.trim() === "") {
                            //   setSelectedTenantsForLink([]);
                            // }
                            setSearchText(e.target.value);
                          }}
                          disabled={isPropertyAwarded || simulationLoading}
                        />
                        {haveValue(searchText) ? (
                          <img
                            src={Cancelimg}
                            alt="icon"
                            onClick={() => {
                              // setSelectedTenantsForLink([]);
                              setSearchText("");
                            }}
                            className="canceicon topRightIcon searchCrossIcon"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                    {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                      user?.current_workspace_role
                    ) && (
                      <button
                        className="addGuarantorButton d-flex mx-0 btnNext d-flex jusitfy-content-center align-items-center"
                        onClick={(e) => {
                          setShowEmailModal(true);
                          // setDetailsShow(false);
                        }}
                        disabled={isPropertyAwarded || simulationLoading}
                      >
                        <img src="/images/add-white.svg" />
                        {_t("inviteTenant")}
                      </button>
                    )}
                    {isPropertyAwarded && <ButtonActionTooltip />}
                  </div>
                </div>
              )}

              {saveTanentLoading ? (
                <Loader />
              ) : (
                <>
                  <div
                    className="mobile-single-property"
                    style={
                      simulationLoading
                        ? { opacity: 0.4, pointerEvents: "none" }
                        : {}
                    }
                  >
                    <ul>
                      {getName()?.length > 0 ? (
                        getName()?.map((assignPropData) => {
                          const applicationDetails =
                            getApplicationDetails(assignPropData);
                          const isApplicationRow =
                            applicationDetails?.hasApplication === true;
                          const tenantId =
                            assignPropData?.tenantid?._id ||
                            assignPropData?.value;
                          const applicationId =
                            assignPropData?.application_id?._id;
                          const trackingId = isApplicationRow
                            ? applicationId
                            : tenantId;
                          const isLinking =
                            linkingTenantIds.includes(trackingId);
                          const isUnlinking =
                            unlinkingTenantIds.includes(trackingId);
                          const isProcessing = isLinking || isUnlinking;
                          const hasSelectedTenants =
                            selectedTenant.length > 0 && !isApplicationSelected;
                          const isSelectionDisabled =
                            (isApplicationSelected &&
                              !selectedTenant.includes(assignPropData)) ||
                            (hasSelectedTenants && isApplicationRow);
                          const isOpen =
                            openApplicationIds[assignPropData?._id] === true;

                          const isProfilePending = checkIsProfilePending(
                            assignPropData?.tenantid ??
                              assignPropData?.tenant_id,
                            assignPropData?._id
                          );

                          return (
                            <li
                              className={`d-flex listWrapper linked_li_details linked_li_details2 px-0 ${
                                isApplicationRow ? "linked-application-row" : ""
                              } ${
                                isSelectionDisabled
                                  ? "selection-disabled-row"
                                  : ""
                              }`}
                              style={{
                                ...(isProfilePending
                                  ? {
                                      backgroundColor: "#F5F4ED",
                                      borderColor: "#BEBCBA",
                                      //   borderWidth: "1px",
                                      //   borderStyle: "solid",
                                    }
                                  : {}),
                              }}
                            >
                              <div
                                className={`d-flex w-100 justify-content-between ${
                                  isApplicationRow
                                    ? "align-items-start flex-column"
                                    : "align-items-center"
                                }`}
                              >
                                <div
                                  className={`linked_li_div d-flex align-items-center custom-gap-2 w-100 ${
                                    isApplicationRow
                                      ? ""
                                      : "justify-content-center"
                                  }`}
                                >
                                  {!haveValue(searchText) && (
                                    <div
                                      className={`checkboxWrapper d-flex align-items-center justify-content-center ${
                                        isPropertyAwarded ||
                                        !WORKSPACE_ROLES_CAPABILITIES?.tenantManagement?.includes(
                                          user?.current_workspace_role
                                        )
                                          ? "checkboxWrapperDisabled"
                                          : ""
                                      } ${
                                        (isApplicationSelected &&
                                          !selectedTenant.includes(
                                            assignPropData
                                          )) ||
                                        (hasSelectedTenants && isApplicationRow)
                                          ? "checkboxWrapperSelectionDisabled"
                                          : ""
                                      }`}
                                    >
                                      <label
                                        className="custom-gap-3 custom-checkbox mb-0"
                                        style={{
                                          opacity: isProfilePending ? "0" : "",
                                        }}
                                      >
                                        <input
                                          type={`checkbox`}
                                          checked={selectedTenant.includes(
                                            assignPropData
                                          )}
                                          onChange={handleCheckboxChange(
                                            assignPropData
                                          )}
                                          disabled={
                                            isPropertyAwarded ||
                                            !WORKSPACE_ROLES_CAPABILITIES?.tenantManagement?.includes(
                                              user?.current_workspace_role
                                            ) ||
                                            (isApplicationSelected &&
                                              !selectedTenant.includes(
                                                assignPropData
                                              )) ||
                                            (hasSelectedTenants &&
                                              isApplicationRow) ||
                                            isProfilePending
                                          }
                                        />
                                        <span
                                          className={`custom-checkmark`}
                                        ></span>
                                      </label>
                                    </div>
                                  )}
                                  {!isApplicationRow && (
                                    <div
                                      className="earner-thumbnail-wrapper d-flex align-items-center justify-content-center"
                                      style={
                                        isProfilePending
                                          ? { backgroundColor: "#D6D4CE" }
                                          : {}
                                      }
                                    >
                                      <img
                                        src={UserIcon}
                                        style={
                                          isProfilePending
                                            ? { filter: "brightness(0.6)" }
                                            : {}
                                        }
                                      />
                                    </div>
                                  )}
                                  <div
                                    className={`w-100 d-flex justify-content-between`}
                                  >
                                    <div>
                                      {(() => {
                                        const isApplication =
                                          applicationDetails?.hasApplication;

                                        if (isApplication) {
                                          const combinedIncome =
                                            applicationDetails.acceptedParticipants.reduce(
                                              (sum, participant) => {
                                                const incomeAmount =
                                                  getCustomIncomeDetails(
                                                    participant?.tenant_info,
                                                    user,
                                                    _t,
                                                    resolveIncomeSelection(
                                                      assignPropData?.income_selection,
                                                      participant?.tenant_info
                                                        ?._id
                                                    )?.tenant_source,
                                                    undefined,
                                                    undefined,
                                                    deaWorkspace,
                                                    assignPropData?.custom_income_sources
                                                  )?.amount ?? 0;
                                                return sum + incomeAmount;
                                              },
                                              0
                                            );

                                          return (
                                            <div className="application-group-wrapper">
                                              <div
                                                onClick={() =>
                                                  toggleApplicationAccordion(
                                                    assignPropData?._id
                                                  )
                                                }
                                                className="application-group-header cursor-pointer"
                                              >
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                  <span className="position-relative">
                                                    <div className="mobile-profile-info-box">
                                                      <div className="userImageWrapper">
                                                        <img
                                                          src="/images/Flatmates.svg"
                                                          alt="User Icon"
                                                        />
                                                      </div>
                                                    </div>
                                                    {applicationDetails
                                                      ?.participants?.length >
                                                      0 && (
                                                      <div className="member-count-wrapper d-flex align-items-center justify-content-center">
                                                        {
                                                          applicationDetails
                                                            ?.participants
                                                            ?.length
                                                        }
                                                      </div>
                                                    )}
                                                  </span>
                                                  <div>
                                                    <p className="linked_li_score scoreTextProperty mb-0 application-combined-income">
                                                      <div className="d-flex align-items-center gap-2">
                                                        <p className="linked_li_name mb-1">
                                                          {
                                                            applicationDetails?.title
                                                          }
                                                        </p>
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="10"
                                                          height="10"
                                                          viewBox="0 0 8 8"
                                                          fill="none"
                                                          className={`application-chevron ${
                                                            isOpen
                                                              ? "application-chevron-open"
                                                              : ""
                                                          }`}
                                                        >
                                                          <path
                                                            d="M2 1L6 4L2 7"
                                                            stroke="#253837"
                                                            strokeWidth="1.2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                          />
                                                        </svg>
                                                      </div>
                                                      {_t(
                                                        "combinedIncome",
                                                        "Combined income"
                                                      )}
                                                      : {combinedIncome} €/
                                                      {_t("mo")}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }

                                        return (
                                          <>
                                            <p
                                              onClick={() =>
                                                handleOpenProfile(
                                                  assignPropData
                                                )
                                              }
                                              className="linked_li_name d-flex gap-2 align-items-center cursor-pointer"
                                            >
                                              {getUserDisplayName(
                                                assignPropData?.tenantid
                                              )}
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="7"
                                                height="11"
                                                viewBox="0 0 8 13"
                                                fill="none"
                                                className="arrow-icon"
                                              >
                                                <path
                                                  d="M1 12L7 6.5L1 1"
                                                  stroke="#253837"
                                                  strokeWidth="1.4"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                              </svg>
                                            </p>
                                          </>
                                        );
                                      })()}
                                      {/* <p
                                          className="namanhere cursor-pointer"
                                          onClick={(e) => {
                                            setFinalScoreModel(true);
                                            setFinalScoreModelData(
                                              tenantResults[
                                              assignPropData?._id
                                              ],
                                            );
                                          }}
                                        >
                                          {haveValue(
                                            tenantResults[assignPropData?._id]
                                              ?.finalScore,
                                          ) ? (
                                            tenantResults[assignPropData?._id]
                                              ?.finalScore
                                          ) : (
                                            <p className="text-danger">
                                              {
                                                tenantResults[
                                                  assignPropData?._id
                                                ]?.errorMsg
                                              }
                                            </p>
                                          )}
                                        </p> */}
                                      {isProfilePending ? (
                                        <div className="profile-incomplete-card d-flex align-items-center justify-content-center gap-1">
                                          {/* clock icon */}
                                          <img src="/images/clock.svg" alt="" />
                                          <p>{_t("profileIncomplete")}</p>
                                        </div>
                                      ) : (
                                        <>
                                          {!getApplicationDetails(
                                            assignPropData
                                          ).hasApplication && (
                                            <div className="d-flex align-items-center justify-content-start custom-gap-3 score-text-property-margin">
                                              {isDeaRulesActivated ? (
                                                haveValue(
                                                  allDeaResult?.[
                                                    assignPropData?._id
                                                  ]
                                                ) ? (
                                                  (() => {
                                                    const result =
                                                      renderIndividualDeaResult(
                                                        assignPropData?._id
                                                      );
                                                    return (
                                                      <>
                                                        <p
                                                          className="deaIndividualStatus d-flex align-items-center custom-gap-2"
                                                          style={{
                                                            background:
                                                              result.backgroundColor,
                                                            // border: result.border,
                                                            color: result.color,
                                                            fontWeight:
                                                              result.fw,
                                                          }}
                                                        >
                                                          <img
                                                            src={result.img}
                                                          />
                                                          {
                                                            result.deaIndividualText
                                                          }
                                                        </p>
                                                        <span className="deaIndividualIncome">
                                                          •
                                                        </span>
                                                        <p className="deaIndividualIncome">
                                                          {(() => {
                                                            const tInfo =
                                                              assignPropData?.tenantid;
                                                            return (
                                                              getCustomIncomeDetails(
                                                                tInfo,
                                                                user,
                                                                _t,
                                                                resolveIncomeSelection(
                                                                  assignPropData?.income_selection,
                                                                  assignPropData
                                                                    ?.tenantid
                                                                    ?._id
                                                                )
                                                                  ?.tenant_source,
                                                                undefined,
                                                                undefined,
                                                                deaWorkspace,
                                                                assignPropData?.custom_income_sources
                                                              )?.amount ?? 0
                                                            );
                                                          })()}{" "}
                                                          €{"/"}
                                                          {_t("mo")}
                                                        </p>
                                                      </>
                                                    );
                                                  })()
                                                ) : !isPropertyAwarded ? (
                                                  <Loader />
                                                ) : null
                                              ) : (
                                                <>
                                                  <p className="linked_li_score scoreTextProperty scoreTextDivider">
                                                    {_t("income")}:{" "}
                                                    {getTenantIncomeDetails(
                                                      assignPropData
                                                    )?.amount ?? 0}{" "}
                                                    €{"/"}
                                                    {_t("mo")}
                                                  </p>
                                                  <p
                                                    className={`scoreTextProperty ${
                                                      isInsurableEnabledLandlord
                                                        ? "scoreTextDivider"
                                                        : ""
                                                    }`}
                                                    style={{
                                                      marginLeft: "4px",
                                                    }}
                                                  >
                                                    {_t("effortRate")}:{" "}
                                                    {calculateRentAmount(
                                                      assignPropData
                                                    )}
                                                    {"% "}
                                                  </p>
                                                  {
                                                    isInsurableEnabledLandlord &&
                                                      (() => {
                                                        const defaulter =
                                                          isDefaulter(
                                                            assignPropData
                                                              ?.tenantid
                                                              ?.tenant_extra_field_id
                                                              ?.experianJson?.[
                                                              "s:Envelope"
                                                            ]?.["s:Body"]
                                                              ?.GenerarInformeResponse
                                                              ?.GenerarInformeResult
                                                              ?.InformeDelphi4A3
                                                          );
                                                        return (
                                                          <p
                                                            className="scoreTextProperty"
                                                            style={{
                                                              color: !defaulter
                                                                ? "#82cf3f"
                                                                : "#ff3c3c",
                                                              marginLeft: "4px",
                                                            }}
                                                          >
                                                            {!defaulter
                                                              ? _t(
                                                                  "defaultFree"
                                                                )
                                                              : _t("defaulter")}
                                                          </p>
                                                        );
                                                      })()
                                                    // <p className="scoreTextProperty custom-gap-2 d-flex align-items-center">
                                                  }
                                                </>
                                              )}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                    {WORKSPACE_ROLES_CAPABILITIES?.properties?.linkTenant?.includes(
                                      user?.current_workspace_role
                                    ) && (
                                      <div
                                        className={`share-it ${
                                          isApplicationRow
                                            ? "application-share-actions"
                                            : ""
                                        }`}
                                      >
                                        {searchText &&
                                        !(
                                          selectedTanents.includes(
                                            getTenantId(assignPropData)
                                          ) ||
                                          applicationDetails.participants.some(
                                            (p) =>
                                              selectedTanents.includes(p.id)
                                          )
                                        ) ? (
                                          <Link
                                            className="share-btn shareBtnModal"
                                            onClick={() => {
                                              if (!isLinking) {
                                                handleTenantSelect(
                                                  assignPropData,
                                                  "notSelected"
                                                );
                                              }
                                            }}
                                            style={
                                              isProfilePending
                                                ? {
                                                    backgroundColor: "#F5F4ED",
                                                    borderColor: "#BEBDB6",
                                                    borderWidth: "1px",
                                                    borderStyle: "solid",
                                                  }
                                                : {}
                                            }
                                          >
                                            <img
                                              src="/images/share-icon.svg"
                                              alt=""
                                            />
                                            {isLinking
                                              ? `${_t("unlinking")}...`
                                              : _t("link")}
                                          </Link>
                                        ) : searchText ? (
                                          <Link
                                            className={`share-btn shareBtnModal selected ${isProfilePending ? "profile-incomplete" : ""}`}
                                            onClick={() => {
                                              if (!isLinking) {
                                                handleTenantSelect(
                                                  assignPropData,
                                                  "selected"
                                                );
                                              }
                                            }}
                                          >
                                            {isLinking
                                              ? `${_t("linking")}...`
                                              : _t("unLink")}
                                          </Link>
                                        ) : (
                                          <button
                                            className={`share-btn btnNext ${isProfilePending ? "profile-incomplete" : ""}`}
                                            onClick={(e) => {
                                              if (!isUnlinking) {
                                                handleUnLinkSingle(
                                                  e,
                                                  assignPropData
                                                );
                                              }
                                            }}
                                            disabled={isPropertyAwarded}
                                          >
                                            {isUnlinking
                                              ? `${_t("unlinking")}...`
                                              : _t("unLink")}
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                {isOpen && (
                                  <div className="application-participants-list">
                                    {applicationDetails.participants.map(
                                      (participant, index) => {
                                        const participantInfo =
                                          participant?.tenant_info;
                                        const participantName = participantInfo
                                          ? getUserDisplayName(participantInfo)
                                          : participant?.email;
                                        const initials =
                                          participantName
                                            ?.split(" ")
                                            ?.filter(Boolean)
                                            ?.slice(0, 2)
                                            ?.map((part) =>
                                              part?.[0]?.toUpperCase()
                                            )
                                            ?.join("") || "U";

                                        const isPrimary =
                                          participant?.isPrimary;

                                        if (!participantInfo) {
                                          return (
                                            <div
                                              key={`${assignPropData?._id}-participant-${index}`}
                                              className="application-participant-item cursor-pointer"
                                              onClick={() =>
                                                handleOpenParticipantProfile(
                                                  participant,
                                                  assignPropData?._id
                                                )
                                              }
                                            >
                                              <span className="application-participant-avatar">
                                                {initials}
                                              </span>
                                              <div className="application-participant-content">
                                                <p className="application-participant-name">
                                                  {participantName}
                                                </p>
                                                <p className="application-participant-meta">
                                                  {_t("pending")}
                                                </p>
                                              </div>
                                            </div>
                                          );
                                        }
                                        const participantIncome =
                                          getCustomIncomeDetails(
                                            participantInfo,
                                            user,
                                            _t,
                                            resolveIncomeSelection(
                                              assignPropData?.income_selection,
                                              participant?.tenant_info?._id
                                            )?.tenant_source,
                                            undefined,
                                            undefined,
                                            deaWorkspace,
                                            assignPropData?.custom_income_sources
                                          )?.amount ?? 0;
                                        const participantEffort =
                                          getRentPercentage(
                                            participantIncome,
                                            rent
                                          )?.roundValue ?? 0;
                                        const participantRole = isPrimary
                                          ? _t("owner", "Titular")
                                          : _t("flatmate", "Compañero/a");

                                        return (
                                          <div
                                            key={`${assignPropData?._id}-participant-${index}`}
                                            className="application-participant-item cursor-pointer"
                                            onClick={() =>
                                              handleOpenParticipantProfile(
                                                participant,
                                                assignPropData?._id
                                              )
                                            }
                                          >
                                            <span className="application-participant-avatar">
                                              {initials}
                                            </span>
                                            <div className="application-participant-content w-100">
                                              <div className="d-flex justify-content-between items-center w-100">
                                                <p className="application-participant-name">
                                                  {participantName}
                                                </p>
                                                {participant?.consent_status ===
                                                  "pending" && (
                                                  <span className="participant-status-badge participant-status-pending">
                                                    {_t(
                                                      "pendingSharingProfile"
                                                    )}
                                                  </span>
                                                )}
                                              </div>
                                              <p className="application-participant-meta">
                                                {participantRole} •{" "}
                                                {participantIncome} €/
                                                {_t("mo")} • {_t("effortRate")}:{" "}
                                                {participantEffort}%
                                              </p>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                )}
                              </div>
                            </li>
                          );
                        })
                      ) : (
                        <p className="notSharedText text-center">
                          {_t("noDataFound")}
                        </p>
                      )}
                    </ul>
                  </div>
                  {/* {isInsurableEnabledLandlord && selectedTenant?.length > 0 && (
                    <div className="doc-history-content doc-history-content-insurance">
                      <div className="d-flex align-items-center custom-gap-3 justify-content-between header-wrapper-insurance">
                        <h4>{_t("rentalInsurance")}</h4>
                        <div className="optional-insurance">
                          {_t("optional")}
                        </div>
                      </div>

                      <div
                        style={{ flexWrap: "nowrap" }}
                        className="d-flex align-items-start custom-gap-2"
                      >
                        <div
                          className="checkmarkWrapper"
                          style={{
                            background: areAllSelectedTenantsInsurable
                              ? "transparent"
                              : "#FFE2E2",
                          }}
                        >
                          <img
                            className="commonClassImage"
                            src={
                              areAllSelectedTenantsInsurable
                                ? "/images/checkmark-grey.svg"
                                : notIcon
                            }
                            alt="checkmark-icon"
                          />
                        </div>
                        <div className="d-flex flex-column custom-gap-2">
                          {areAllSelectedTenantsInsurable ? (
                            <p>
                              {_t(
                                "allSelectedTenantsAreEligibleInsuranceWillApplyToAllOfThemIfPurchased"
                              )}
                            </p>
                          ) : (
                            <p>
                              {_t(
                                "someTenantsReuireAManualReviewBeforeRequestingTheInsurance"
                              )}
                            </p>
                          )}
                          <a
                            href="/pdf/Mom_seguroimpagoalquiler.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {_t("insurancePolicy")}
                          </a>
                        </div>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            if (
                              !areAllSelectedTenantsInsurable ||
                              !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                                user?.current_workspace_role
                              )
                            ) {
                              console.log("Not allowed");
                            } else {
                              setInsuracePopupModal(true);
                            }
                          }}
                          className="addGuarantorButton d-flex mx-0 btnNext purchaseInsuranceButton d-flex jusitfy-content-center align-items-center"
                          disabled={
                            !areAllSelectedTenantsInsurable ||
                            !WORKSPACE_ROLES_CAPABILITIES?.properties?.purchaseInsurance?.includes(
                              user?.current_workspace_role
                            )
                          }
                        >
                          {_t("requestInsurance")}
                        </button>
                      </div>
                    </div>
                  )} */}
                </>
              )}
            </div>
            {saveTanentLoading ? (
              ""
            ) : (
              <>
                {/* <div className="linked-property-popup-padding">
                  <div className="chat-with-sopport-bottom-fixed">
                    {isPropertyAwarded &&
                      haveValue(property?.insurance_payment_date) &&
                      (moment().diff(
                        moment(property.insurance_payment_date),
                        "hours"
                      ) <= 24 ? (
                        // CASE 1: Insurance date within 24 hours
                        <div className="doc-history-content doc-history-content-insurance doc-history-within-24hrs">
                          <div className="d-flex align-items-center custom-gap-3 justify-content-between header-wrapper-insurance">
                            <h4>{_t("processingInsurance")}</h4>
                            <div className="optional-insurance">
                              {_t("optional")}
                            </div>
                          </div>

                          <div className="d-flex align-items-start custom-gap-2">
                            <IoStopwatchOutline className="commonClassImage" />
                            <div className="d-flex flex-column custom-gap-2">
                              <p>
                                {_t(
                                  "yourInsuraceIseingProcessedAndWillBeSentToYourEmailWithinTwentyFourHours"
                                )}
                              </p>
                              <a
                                href="/pdf/Mom_seguroimpagoalquiler.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {_t("insurancePolicy")}
                              </a>
                            </div>
                          </div>
                        </div>
                      ) : (
                        // CASE 2: Older than 24 hours
                        <div className="doc-history-content">
                          <p>
                            {_t(
                              "yourInsuranceWasSuccessfullyProcessedAndNextStepsWereSentToYourEmailInCaseOfAnyQuestionsPleaseContactOurSupportChat"
                            )}
                          </p>
                          <a
                            href="https://wa.me/34617662602"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {_t("chatWithSupport")}
                          </a>
                        </div>
                      ))}
                  </div>
                </div> */}
                {selectedTenant.length > 0 || isPropertyAwarded ? (
                  <div
                    className="rental-overview-footer"
                    style={{
                      borderTop: !isPropertyAwarded
                        ? statusStyle.border
                        : "2px solid #DAECC8",
                      backgroundColor: !isPropertyAwarded
                        ? statusStyle.backgroundColor
                        : "#F2FBE9",
                    }}
                  >
                    {WORKSPACE_ROLES_CAPABILITIES?.propertyManagement?.includes(
                      user?.current_workspace_role
                    ) && (
                      <div
                        className={`
                        buttonset_css d-flex align-items-center justify-content-between gap-2
                        ${isDeaRulesActivated || isPropertyAwarded ? "dea-buttonset_css" : ""}
                      `}
                      >
                        {resultLoader ? (
                          <img
                            src={SkorDefaultLoader}
                            className="defaultSkorLoader"
                            alt="Example"
                          />
                        ) : (
                          <>
                            {!isPropertyAwarded ? (
                              <div className="d-flex w-100 align-items-start d-flex flex-column">
                                <span
                                  style={{
                                    color:
                                      statusStyle.textColor ||
                                      statusStyle.color,
                                    fontWeight: statusStyle.fw,
                                  }}
                                >
                                  {statusStyle.img && (
                                    <img src={statusStyle.img} alt="" />
                                  )}
                                  {statusStyle.text}
                                </span>

                                {/* computed description (uses verdict, enabled, recommendationFlags, showAddGuarantor) */}
                                {isRecommendationRulesActivated &&
                                  selectedTenant.length > 0 &&
                                  !isDeaRulesActivated && (
                                    <p
                                      className="status-description mt-1"
                                      style={{
                                        margin: 0,
                                        color:
                                          statusStyle.textColor ||
                                          statusStyle.color,
                                      }}
                                    >
                                      {(() => {
                                        try {
                                          if (
                                            lastVerdict === "Rejected" &&
                                            lastRecommendationFlags &&
                                            !Object.values(
                                              lastRecommendationFlags
                                            ).some(Boolean)
                                          ) {
                                            return _t("HardFailDescInOverview");
                                          }

                                          if (
                                            lastVerdict === "Approved" ||
                                            enabled
                                          )
                                            return _t(
                                              "approvedApplicationDescription",
                                              "Inside recommendation engine text"
                                            );
                                          if (
                                            lastRecommendationFlags?.completeProfile
                                          )
                                            return _t(
                                              "completeProfileDescription",
                                              "Inside recommendation engine text"
                                            );
                                          if (
                                            lastShowAddGuarantor &&
                                            lastRecommendationFlags?.buyInsurance
                                          )
                                            return _t(
                                              "addGuarantorOrInsuranceDescription",
                                              "Inside recommendation engine text"
                                            );
                                          if (lastShowAddGuarantor)
                                            return _t(
                                              "addGuarantorDescription",
                                              "Inside recommendation engine text"
                                            );
                                          if (
                                            lastRecommendationFlags?.buyInsurance
                                          )
                                            return _t(
                                              "buyInsuranceDescription",
                                              "Inside recommendation engine text"
                                            );
                                        } catch (e) {
                                          return "";
                                        }
                                        return "";
                                      })()}
                                    </p>
                                  )}
                              </div>
                            ) : (
                              <span
                                style={{ color: "#82CF3F", fontWeight: "600" }}
                              >
                                <img src={"/images/awarded.svg"} alt="" />
                                {_t("awarded")}
                              </span>
                            )}
                            <div className="d-flex align-items-center justify-content-end custom-gap-2 w-100">
                              {awardInsuranceSimulationLoading ? (
                                <span
                                  style={{
                                    fontSize: "0.9028vw",
                                    color: "#7f7f7f",
                                    marginRight: "auto",
                                  }}
                                >
                                  {_t(
                                    "processingYourRequestThisMayTakeAMoment",
                                    "Procesando tu solicitud, esto puede tardar un momento…"
                                  )}
                                </span>
                              ) : (
                                <>
                                  {isDeaRulesActivated ? (
                                    WORKSPACE_ROLES_CAPABILITIES?.tenants?.generateReport?.includes(
                                      user?.current_workspace_role
                                    ) && (
                                      <button
                                        onClick={generateReport}
                                        disabled={
                                          !checkAllTenantsHaveAcceptedSharing(
                                            selectedTenant
                                          ) ||
                                          (selectedTenant.length === 0 &&
                                            !isPropertyAwarded)
                                        }
                                        type="button"
                                        className="btnNext rental-overview-white-button commonButtonPropertyDark commonButtonPropertyLight"
                                      >
                                        {_t("generateReport")}
                                      </button>
                                    )
                                  ) : isRecommendationRulesActivated ? (
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        const generatedReport =
                                          renderFinalResult(true);
                                        setRiskReportData(generatedReport);
                                        setShowRiskAssessmentReportModal(true);
                                      }}
                                      disabled={
                                        !checkAllTenantsHaveAcceptedSharing(
                                          selectedTenant
                                        ) ||
                                        selectedTenant.length === 0 ||
                                        hasMissingPropertyDetails ||
                                        !rent ||
                                        simulationLoading
                                      }
                                      type="button"
                                      className="btnNext rental-overview-white-button commonButtonPropertyDark commonButtonPropertyLight"
                                    >
                                      {_t("viewDetails")}
                                    </button>
                                  ) : (
                                    WORKSPACE_ROLES_CAPABILITIES?.tenants?.generateReport?.includes(
                                      user?.current_workspace_role
                                    ) && (
                                      <button
                                        onClick={generateReport}
                                        disabled={
                                          !checkAllTenantsHaveAcceptedSharing(
                                            selectedTenant
                                          ) ||
                                          (selectedTenant.length === 0 &&
                                            !isPropertyAwarded)
                                        }
                                        type="button"
                                        className="btnNext rental-overview-white-button commonButtonPropertyDark commonButtonPropertyLight"
                                      >
                                        {_t("generateReport")}
                                      </button>
                                    )
                                  )}
                                  {!isPropertyAwarded &&
                                    WORKSPACE_ROLES_CAPABILITIES?.properties?.award?.includes(
                                      user?.current_workspace_role
                                    ) && (
                                      <button
                                        style={{
                                          backgroundColor: simulationLoading
                                            ? "#82CF3F"
                                            : statusStyle.color,
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "0.5556vw",
                                          flexWrap: "nowrap",
                                          whiteSpace: "nowrap",
                                        }}
                                        onClick={() => {
                                          if (selectedTenant.length !== 0) {
                                            if (isInsurableEnabledLandlord) {
                                              runInsuranceSimulationHandler(
                                                "award",
                                                true
                                              );
                                            } else {
                                              setShowAwardInsurancePopup(true);
                                            }
                                            setShowRiskAssessmentReportModal(
                                              false
                                            );
                                          }
                                        }}
                                        type="button"
                                        disabled={
                                          !checkAllTenantsHaveAcceptedSharing(
                                            selectedTenant
                                          ) ||
                                          selectedTenant.length === 0 ||
                                          simulationLoading ||
                                          (isRecommendationRulesActivated &&
                                            !isDeaRulesActivated &&
                                            lastVerdict === "Rejected") ||
                                          hasMissingPropertyDetails ||
                                          !rent
                                        }
                                        className="btnNext commonButtonPropertyDark"
                                      >
                                        {simulationLoading && (
                                          <LoadingSpinner
                                            size="1.1111vw"
                                            color="#253837"
                                            borderWidth={2}
                                          />
                                        )}
                                        {simulationLoading
                                          ? _t("analysingFeasibility")
                                          : _t("awardProperty")}
                                      </button>
                                    )}
                                </>
                              )}
                              {isPropertyAwarded &&
                              WORKSPACE_ROLES_CAPABILITIES?.properties?.award?.includes(
                                user?.current_workspace_role
                              ) ? (
                                <button
                                  onClick={handleUnAwardProperty}
                                  className="commonButtonPropertyDark commonButtonPropertyLight"
                                  style={{
                                    background: "#d74142",
                                    color: "#fff",
                                  }}
                                >
                                  {_t("unAwardProperty")}
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      )}
      <AwardPropertyPopup
        awardPopupModal={awardPopupModal}
        setAwardPopupModal={setAwardPopupModal}
        selectedTenants={
          isPropertyAwarded ? propertyAwardedSelectedTenant : selectedTenant
        }
        property={property}
        rentVal={rent}
        currentLang={currentLang}
      />
      <PurchaseInsurancePopup
        insuracePopupModal={insuracePopupModal}
        // insuracePopupModal={true}
        setInsuracePopupModal={setInsuracePopupModal}
        selectedTenants={
          isPropertyAwarded ? propertyAwardedSelectedTenant : selectedTenant
        }
        property={property}
        rent={rent}
        insuranceCost={simulatedInsuranceCost}
        preFilledInsuranceDocument={preFilledInsuranceDocument}
      />
      <Modal
        show={showEmailModal}
        onHide={(e) => setShowEmailModal(false)}
        centered
        className="newmodalui wrapper-modal inviteTenantModal max-w-lg"
      >
        <Modal.Header>
          <Modal.Title>{_t("inviteTenant")}</Modal.Title>
          <div
            className="cursor-pointer"
            onClick={() => setShowEmailModal(false)}
          >
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="qr-link-copi"> */}
          <form
            onSubmit={sendInvitationViaEmail}
            className="d-flex flex-wrap justify-content-between"
          >
            <div className="form-group customInput col-6 bodyContentset">
              <label>{_t("name")}</label>
              <input
                type="text"
                onChange={(e) => {
                  setSharerName(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("enterName")}
                onBeforeInput={(e) => {
                  const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
                  if (!isValidChar) e.preventDefault();
                }}
              />
            </div>
            <div className="form-group customInput col-6 bodyContentset">
              <label>{_t("email")}</label>
              <input
                type="email"
                onChange={(e) => {
                  setSharerEmail(e.target.value);
                }}
                className="form-control"
                required={true}
                placeholder={_t("enterEmail")}
                onBeforeInput={(e) => {
                  if (!e.data) return; // allow delete, etc.

                  const value = e.data;

                  // Allow full pasted string
                  const isValid = /^[a-z0-9._%+-@]+$/.test(value);

                  if (!isValid) {
                    e.preventDefault();
                    return;
                  }

                  // Prevent multiple @ (handle paste too)
                  const existingValue = e.target.value;
                  const totalAtCount =
                    (existingValue + value).split("@").length - 1;

                  if (totalAtCount > 1) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div className="col-12 mt-3  d-flex justify-content-center">
              <button
                type="submit"
                className="btnNext commonButtonPropertyDark"
                disabled={sendInvitationLoading}
              >
                {_t("sendInvite")}
              </button>
            </div>
          </form>
          {/* </div> */}
        </Modal.Body>
      </Modal>
      <Modal
        show={showUnAwardSuccessPopup}
        onHide={(e) => setShowUnAwardSuccessPopup(false)}
        centered
        className="newmodalui wrapper-modal inviteTenantModal max-w-lg awardPropertyModal text-center"
      >
        <Modal.Header>
          <div
            className="cursor-pointer"
            onClick={() => setShowUnAwardSuccessPopup(false)}
          >
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <h2>{_t("unAwardedProp")}</h2>
          <p>{_t("propertyUnawardedSuccessfully")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btngreen add-landlord-submit"
            onClick={() => setShowUnAwardSuccessPopup(false)}
          >
            {_t(
              "underStoodButtonAfterUnAwardProp",
              "New award property succes modal"
            )}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={finalScoreModel}
        onHide={(e) => setFinalScoreModel(false)}
        centered
        className="newmodalui wrapper-modal inviteTenantModal max-w-lg awardPropertyModal text-center"
      >
        <Modal.Header>
          <div
            className="cursor-pointer"
            onClick={() => setFinalScoreModel(false)}
          >
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {haveValue(finalScoreModelData) && (
            <>
              <h4>Pillars</h4>
              <ol>
                {Object?.entries(finalScoreModelData?.pillars)?.map(
                  ([key, value]) => (
                    <li key={key}>
                      {key}-{value}
                    </li>
                  )
                )}
              </ol>
              <h4>Sub-Scores</h4>
              <ol>
                {Object?.entries(finalScoreModelData?.subScores)?.map(
                  ([key, value]) => (
                    <li key={key}>
                      {key}-{value}
                    </li>
                  )
                )}
              </ol>
              <h4>Is Hard fail</h4>
              <p>{finalScoreModelData?.isHardFail ? "Yes" : "No"}</p>
              <h4>Error Entries</h4>
              <ol>
                {finalScoreModelData?.errorEntries?.length ? (
                  finalScoreModelData.errorEntries.map((entry, index) => (
                    <li key={index}>{entry?.[0]}</li>
                  ))
                ) : (
                  <li>N/A</li>
                )}
              </ol>
            </>
          )}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <SuccessAwardedPropModal
        showSuccessPopup={showSuccessPopup}
        setShowSuccessPopup={setShowSuccessPopup}
        property={property}
        successTenant={successTenant}
      />
      <ServingPromptModal
        openModal={servingPromptModal}
        profile={currentProfile}
        URL={
          servingPromptModalURL ||
          // user?.isParentLL
          //   ? `/${workspaceId}/profile-property?agencylink=${currentProfile?.agency_tenant_link_id}`
          //   :
          `/${workspaceId}/profile-property?sharedprofileid=${currentProfile?._id}`
        }
        setOpenModal={() => {
          setServingPromptModal(false);
          setServingPromptModalURL("");
        }}
      />
      <InsuranceSimulationErrorsModal
        show={Boolean(insuranceSimulationErrorModal)}
        type={insuranceSimulationErrorModal}
        onHide={() => setInsuranceSimulationErrorModal(false)}
        errors={insuranceSimulationErrors}
        onAction={() => {
          setInsuranceSimulationErrorModal(false);
        }}
      />
      <InsuranceReviewModal
        show={showInsuranceReviewModal}
        onHide={() => setShowInsuranceReviewModal(false)}
        onGotIt={() => {
          setShowInsuranceReviewModal(false);
        }}
      />
      {showAwardInsurancePopup && (
        <AwardInsuranceConfirmPopup
          show={showAwardInsurancePopup}
          onHide={() => setShowAwardInsurancePopup(false)}
          onConfirm={(addInsurance) => {
            if (addInsurance) {
              setInsuracePopupModal(true);
            } else {
              handleAwardPropFlow();
            }
          }}
          selectedTenant={selectedTenant}
          property={property}
          currentLang={currentLang}
          isInsuranceToggleEnabled={lastVerdict === "Conditional"}
          preFilledInsuranceDocument={preFilledInsuranceDocument}
          isInsurable={isInsuranceSimulationSuccess}
        />
      )}
    </>
  );
};

export default LinkedPropertiesPopup;
